AoPS.Community.Lang = {
	/* General usage */
	"Add-Note": "Add Note",
	Admin: "Admin",
	Administrators: "Administrators",
	At: "At",
	"Back-to": "Back to",
	Banned: "Banned",
	blog: "blog",
	Bookmarks: "Bookmarks",
	Build: "Build",
	by: "by",
	By: "By",
	cancel: "cancel",
	Cancel: "Cancel",
	collection: "collection",
	"command-click": "command-click",
	Community: "Community",
	Contributors: "Contributors",
	"control-click": "control-click",
	Conversations: "Conversations",
	create: "create",
	Create: "Create",
	Custom: "Custom",
	"data-saved": "Data saved!",
	"data-saved-reload":
		"Data saved!  You will see your changes when you reload the community",
	Delete: "Delete",
	Email: "Email",
	"Enter-username": "Enter username",
	FAQ: "Help",
	Flyout: "Flyout",
	forum: "forum",
	Forum: "Forum",
	Full: "Full",
	in: "in",
	Info: "Info",
	information: "information",
	IP: "IP",
	"logged-out": "You have been signed out.  Please sign back in and try again.",
	"Login/Join": "Login / Join",
	Message: "Message",
	Messages: "Messages",
	Mod: "Mod",
	Modal: "Modal",
	Moderators: "Moderators",
	MyAoPS: "My AoPS",
	no: "No",
	No: "No",
	NO: "NO",
	None: "None",
	Note: "Note",
	Notes: "Notes",
	"permanent-link": "Permanent Link",
	Popup: "Pop-up",
	Private: "Private",
	"Private-Messages": "Private Messages",
	"Private-Message-Search": "Private Message Search",
	Profile: "Profile",
	Public: "Public",
	Readers: "Readers",
	Reason: "Reason",
	Reset: "Reset",
	Save: "Save",
	saved: "saved",
	"saving-blocker": "Saving data...  Back soon.",
	SEARCH: "SEARCH",
	"search-no-match": "Nothing matches your input.",
	Search: "Search",
	"Search-Results": "Search Results",
	Short: "Short",
	Submit: "Submit",
	Subscribe: "Subscribe",
	Tag: "Tag",
	Tall: "Tall",
	"unexpected-error-code":
		"There has been an unexpected error.  Please contact tech-support@aops.com and tell them exactly\
		 what you were doing to trigger this, and include this magic code: ",
	"unexpected-logout":
		"You have been signed out\
					by nefarious computer gremlins.  If you are in the middle\
					of entering text, you should copy your work before logging back in.",
	Users: "Users",
	Unsubscribe: "Unsubscribe",
	Username: "Username",
	views: "views",
	viewing: "viewing",
	view: "view",
	Welcome: "Welcome",
	yes: "Yes",
	Yes: "Yes",
	YES: "YES",

	/* Months */
	"month-01": "January",
	"month-02": "February",
	"month-03": "March",
	"month-04": "April",
	"month-05": "May",
	"month-06": "June",
	"month-07": "July",
	"month-08": "August",
	"month-09": "September",
	"month-10": "October",
	"month-11": "November",
	"month-12": "December",

	/* Etc */
	"admin-validation":
		'<div>Enter magic admin phrase<br><input name="admin-validate" type="password"></input></div>',
	"admin-validate-failed": "Validation failed",
	"ajax-error-delay":
		"Error talking to the server.  Check your internet connection.  We'll try again in {0} seconds.",
	"ajax-error-E_AJAX_UNKNOWN":
		"An error has occurred that is preventing your computer from connecting to the \
		AoPS site.  Please check your internet connection and then refresh the page.  If you are working on something, please save your work \
		before refreshing.",
	"user-item-online": '<span class="cmty-user-online">Online</span>',
	"invalid-user": "The username <b>{0}</b> is not a valid username.",
	"tag-tooltip-forum": "In forum: ",
	"error-timeout":
		"The server has timed out while working on your request. Please\
		refresh the page to see if it finished what it was supposed to do before so\
		ignominiously giving up.",
	"err-no-such-session":
		"Sorry, your session appears to have changed, so you must refresh \
		your browser before continuing to use the site.  This can happen when you \
		are logged in to Art of Problem Solving on multiple tabs of the same browser, and then \
		sign out on one of those tabs.  Please refresh your browser after saving any work you have \
		in progress.",
	"err-dropzone-fallback":
		"Sorry, attaching documents in our community is not supported by your browser.  Please choose another browser.",
	"err-unknown":
		"Unknown error occurred.  Here's the code they gave me: <b>{0}</b>.",
	"err-no-permission":
		"Sorry, you do not have permission to perform this action.",
	"editable-length-limit-exceeded-on-paste":
		"You pasted too much!  I'm cutting some out.",
	"user-list-validation-blocker": "Validating username...",
	"err-bookmark-limit-reached":
		"Bookmark limit reached.  This item was not bookmarked.",
	"err-community-disabled": AoPS.bootstrap_data.hasOwnProperty(
		"community_inactive_message"
	)
		? AoPS.bootstrap_data.community_inactive_message
		: "Sorry, but the community is currently disabled.  Please try again later.",
	"category-deleted":
		"The page you are viewing has just been deleted.  Sorry about that. \
		I'm going to take you back to the front of the community.",
	"please-wait": "Hold on a sec while I take care of this.",
	"private-search-results": "Private Message Search Results",
	"unwatch-success":
		"Unwatch successful.  You will no longer receive email notifications regarding this {0}. It will miss you.  This {0} is \
		still bookmarked, but you won't receive email notifications any more.",
	"cmty-itembox-loader": "Loading more...",
	"my-profile-home": "My AoPS",
	"initial-fetch-err-E_SEARCH_SERVER_INACTIVE":
		"Sorry, the search server is down right now.  We're working on it.",
	"initial-fetch-err-E_BAD_SEARCH_QUERY":
		'Sorry, you sent the search server something that it cannot parse.  Please try something different. \
		<a href="/community/search" data-cmty>Click here</a> to go to the Advanced Search page. ',
	"initial-fetch-err-E_DONT_KNOW_CHARACTERS":
		'Sorry, your search term only includes special characters that our search engine ignores. \
		<a href="/community/search" data-cmty>Click here</a> to go to the Advanced Search page.',
	"initial-fetch-blog-err-E_SEARCH_SERVER_INACTIVE":
		"Sorry, the search server is down right now.  We're working on it.",
	"initial-fetch-blog-err-E_BAD_SEARCH_QUERY":
		'Sorry, you sent the search server something that it cannot parse.  Please try something different. \
		<a href="/community/c{0}">Click here</a> to go back to the blog. ',
	"initial-fetch-blog-err-E_DONT_KNOW_CHARACTERS":
		'Sorry, your search term only includes special characters that our search engine ignores. \
		<a href="/community/c{0}">Click here</a> to go back to the blog.',
	"initial-fetch-blog-err-E_AJAX_TIMEOUT":
		"Sorry, your request for blog posts is taking too long.  Please try again in a bit.",
	"topic-fetch-err-E_SEARCH_SERVER_INACTIVE":
		"Sorry, the search server is down right now.  We're working on it.",
	"initial-fetch-err-E_AJAX_TIMEOUT":
		"Sorry, your request for community topics is taking too long.  Please try again in a bit.",
	"topic-fetch-err-E_AJAX_TIMEOUT":
		"Sorry, your request for more topics is taking too long.  Please try again in a bit.",
	"topic-fetch-err-E_WRONG_TYPE":
		"Invalid type provided. Must be positive integer.",
	"community-asleep":
		"The AoPS Community has gone to sleep due to inactivity.  \
		If you are in the middle of working on something, \
		then we recommend that you close this message and save your work on your own computer before \
		refreshing the page to reactivate the Community.",
	"community-asleep-reminder":
		"The AoPS Community has gone to sleep due to prior inactivity.  Please \
		refresh the page to reactivate the community.",
	"community-asleep-save":
		"The AoPS Community has gone to sleep due to inactivity.  \
		If you are in the middle of working on something, \
		then we recommend that you close this message and save your work on your own computer before \
		refreshing the page to reactivate the Community.",
	"community-asleep-session":
		"The AoPS Community has gone to sleep due to a session error.  \
		If you are in the middle of working on something, \
		then we recommend that you close this message and save your work on your own computer before \
		refreshing the page to reactivate the Community.",
	"community-asleep-reminder-session":
		"The AoPS Community has gone to sleep due to a session error.  Please \
		refresh the page to reactivate the community.",
	"community-asleep-save-session":
		"The AoPS Community has gone to sleep due to a session error.  \
		If you are in the middle of working on something, \
		then we recommend that you close this message and save your work on your own computer before \
		refreshing the page to reactivate the Community.",
	"view-pdf-tooltip": "View as PDF",

	/* Router */
	"router-err-topic-deleted":
		"You have requested a topic that has been deleted. I am not into dumpster-diving, so I can't get the topic for you.",
	"router-err-no-topic":
		"You have requested a topic that does not exist.  Perhaps it never existed.  Perhaps it was deleted.  Perhaps I'm just tired and don't feel like looking for it.  These AoPS people work me like a dog.",
	"router-err-no-perms-logged-in":
		"You have requested a top secret page for which you have not received security clearance.  Sorry about that.  Perhaps if you do 10 push-ups, I will let you in.",
	"router-err-no-perms-logged-out":
		'You have requested a top secret page for which you have not received security clearance.  Or maybe you have clearance, but you are not signed in. <a class="cmty-login">Click here to sign in</a>.',
	"router-err-no-such-category":
		"I looked and looked, and looked some more.  I'm afraid that the page you requested does not exist.",
	"router-err-no-such-user":
		"I looked and looked, and looked some more.  I'm afraid that the user you requested does not exist.",
	"router-err-no-perms":
		"You do not have permission to view this page." +
		(AoPS.session.logged_in
			? ""
			: ' This may be because you are not signed in! <a class="cmty-login">Click here to sign in</a>.'),
	"router-err-no-post":
		"You have requested a post that does not exist.  Maybe it was deleted.  Maybe it never existed in the first place.  At any rate, I cannot find it.  Sorry about that.",
	"router-err-not-logged-in":
		'You are not signed in to AoPS.  You cannot access this page unless you are logged in. <a class="cmty-login">Click here to sign in</a>.',
	"router-err-cat-admin-no-create-type":
		"You cannot create a category of type ",
	"router-err-not-participant":
		"You are not a participant of this private conversation.",
	"router-err-unwatch-E_NO_HASH_FOUND":
		"Sorry, this link has expired.  That makes me sad, too.",
	"router-edit-profile-crumb": "Edit Profile and Account",
	"router-edit-settings-crumb": "Edit Community Settings",

	/** Breadcrumbs **/
	"breadcrumbs-reported-posts": "Reported Posts",
	"breadcrumbs-tag-info": "Tags",
	"breadcrumbs-terms": "Terms->Tags Map",
	"breadcrumbs-tagmap": "Tags->Terms Map",
	"breadcrumbs-log": "Log: Be careful, yo",

	/* Master Collection */
	"master-other-forums": "Other Forums and Collections ",
	"master-statistics-title": "Statistics:",
	"master-statistics-data":
		"Total posts: <b>{0}</b> | Total topics: <b>{1}</b> | Total members: <b>{2}</b>",
	"master-registered-online": "Registered users online: ",
	"master-collections-modal-title": "What Are Collections and Other Forums?",
	"master-featured-content": "Featured Content ",

	/** Portal **/
	"portal-featured-help-title": "Feature Olympiad Content",
	"portal-extra-content": "Other Forums and Collections ",
	"portal-extra-help-title": "Other Forums and Collections",
	"portal-extra-note": "",
	"portal-extra-logged-in":
		'  <a data-cmty href="/community/edit-settings">Click here</a> to visit your \
		Community settings page, where you can set your default Community homepage view.',

	/* Folder */
	"folder-empty-bookmark_forums":
		"You have no forums bookmarked.  Bookmarked forums will appear on this page.",
	"folder-empty-bookmark_users": "You have no users bookmarked.",
	"folder-empty-folder": "Nothing here yet!",
	"folder-empty-folder_forums": "Nothing here yet!",
	"folder-empty-folder_collections": "Nothing here yet!",
	"folder-empty-blogroll": "No blogs here yet!",
	"folder-empty-my_forums": "No forums here...  Yet!",
	"folder-empty-my_blogs": "No blogs here...  Yet!",
	"folder-empty-my_collections": "No collections here...  Yet!",
	"folder-empty-view_posts": "No posts here yet!",

	/*  Category Cell */
	"cat-cell-no-perm-start-topic":
		"You do not have permission to start a topic in this forum.",
	"cat-cell-no-perm-limited-user":
		'You have a limited account, so you cannot post new topics or replies. \
		You can upgrade your account for free <a href="/user/upgrade.php">here</a>.',
	"cat-cell-no-perm-free-trial":
		"The message board is not included in the free trial version of this class",
	"cat-cell-new-topic": "New Topic",
	"cat-cell-new-message": "New Message",
	"cat-cell-mark-read": "Mark All Read",
	"cat-cell-topic": "topic",
	"cat-cell-topics": "topics",
	"cat-cell-post": "post",
	"cat-cell-posts": "posts",
	"cat-cell-user": "user",
	"cat-cell-users": "users",
	"cat-cell-num-user-title":
		"Number of users viewing a topic in this\n forum in the last five minutes.",
	"cat-cell-no-tag-match": "No tags match your search",
	"cat-cell-filter-placeholder": "Filter by tag",
	"cat-cell-mark-read-title": "Mark all topics in this forum read",
	"cat-cell-bookmark-title": "Bookmark this ",
	"cat-cell-new-topic-title": "Post a new topic to this forum",
	"cat-cell-new-pm-title": "Write a new private message",
	"cat-cell-more-options-title": "More options",
	"cat-cell-create-collection": "Create Collection",
	"cat-cell-help-title": "Learn more about this page",
	"cat-cell-no-tags-yet": " No tags here yet!",
	"cat-cell-no-posts-yet": " No posts here yet!",
	"cat-cell-no-items-yet": " Nothing here yet!",
	"cat-cell-search-forum": "Search this forum",
	"cat-cell-search-pm": "Search private messages",
	"cat-cell-forum-locked-title": "This forum is locked.",
	"cat-cell-forum-locked-title-mod":
		"This forum is locked, but you can post here because you are special.",
	"cat-cell-Locked": "Locked",
	"cat-cell-locked-modal":
		"This forum is currently locked, so you cannot post new topics here right now.",
	"cat-cell-tag-view-topics": "Topics with these tags",
	"cat-cell-forum-view-topics": "Topics in these forums",
	"cat-cell-forum-topics": "Topics in this forum",
	"cat-cell-tags-title": "Tags in this forum",
	"cat-cell-items-title-tag-view": "Tags in this collection",
	"cat-cell-items-title-tag-bookmark": "Tags that I have bookmarked",
	"cat-cell-items-title-forum-view": "Forums in this collection",
	"cat-cell-items-title-forum-bookmark": "Forums that I have bookmarked",
	"cat-cell-no-users-bookmarked": "You have no users bookmarked yet!",
	"cat-cell-view_tags-help-title": "About Tag Collections",
	"cat-cell-view_topics-help-title": "About Topic Collections",

	/* Main page specialty stuff */
	/* Main page breadcrumb */
	"main-crumb-search-placeholder": "Search Community",
	"main-crumb-advanced-search": "Advanced search",
	"cat-search-placeholder-9": "Search Forums",
	"cat-search-placeholder-12": "Search Collections",

	/* Tag box */
	"tagbox-not-logged-in": "You must be signed in to edit a topic's tags.",
	"tagbox-no-permission":
		"You do not have permission to edit tags of topics in this forum.",
	"tagbox-new-user":
		"Once you have been a member of the AoPS Community for at least two weeks, you will be able \
		to edit the tags of existing topics.",

	/* Bookmarks */
	"bookmark-not-logged-in":
		"When you are signed in to AoPS, you will be able to bookmark topics, tags, forums, and users.",
	"bookmark-remove": "Remove",
	"bookmark-follow": "Bookmark",
	"bookmark-limited-user":
		'You have a limited account, so you cannot bookmark items on the site. \
		You can upgrade your account for free <a href="/user/upgrade.php">here</a>, and then you \
		will be able to bookmark items.',
	"bookmark-modal-topic":
		', you are bookmarking the topic "<b>{0}</b>" in the forum <b>{1}</b>. ',
	"bookmark-modal-tag":
		', you are bookmarking the tag "<b>{0}</b>" in the forum <b>{1}</b>. ',
	"bookmark-modal-forum": ", you are bookmarking the forum <b>{0}</b>. ",
	"bookmark-remove-user-title": "Remove this user from Bookmarked Users",
	"bookmark-user-title": "Add this user to Bookmarked Users",
	"bookmark-modal-title": "Bookmark ",
	"bookmark-modal-title-tag": "Bookmark Tag",
	"bookmark-modal-title-topic": "Bookmark Topic",
	"bookmark-modal-title-forum": "Bookmark Forum",
	"bookmark-modal-info-text":
		"All of your bookmarks are available on your My AoPS page.\
		You may also choose to add bookmarked items to your feed and/or receive email notifications.",
	"bookmark-modal-info-text-academy":
		" You may choose to add bookmarked items to your feed and/or receive email notifications.",
	"bookmark-modal-feed": "Add this to my feed.",
	"bookmark-modal-email": "Email me when this gets a new ",
	"bookmark-modal-email-tag": "Email me when a new topic gets this tag.",
	"bookmark-modal-email-topic": "Email me when this topic gets a new post.",
	"bookmark-modal-email-forum":
		"Email me when there is a new post or topic in this forum.",
	"bookmark-modal-cancel": "CANCEL",
	"bookmark-modal-ok": "ADD BOOKMARK",
	"bookmark-no-forums-bookmarked": "You have no forums bookmarked!",
	"bookmark-no-tags-bookmarked": "You have no tags bookmarked!",
	"bookmark-no-topics-bookmarked": "You have no topics bookmarked!",
	"bookmark-tag-tooltip": "Bookmark this tag (subscribe)",
	"remove-bookmarked-tag-tooltip": "Remove tag from bookmarks (unsubscribe)",

	/* Moderate topic */
	"mod-topic-title": "Moderate Topic",
	"mod-topic-move": "Move Topic",
	"mod-topic-unlock": "Unlock Topic",
	"mod-topic-lock": "Lock Topic",
	"mod-topic-delete": "Delete Topic",
	"mod-topic-hard-delete": "Hard Delete Topic",
	"mod-topic-announce": "Make Announcement",
	"mod-topic-global": "Make Global Announcement",
	"mod-topic-normal": "Make Normal Topic",
	"mod-topic-add-target": "Add Target Url",
	"mod-topic-replace-target": "Replace Target Url",
	"mod-topic-remove-target": "Remove Target Url",
	"mod-topic-add-hidden": "Add Hidden Tag",
	"mod-topic-hidden-tags": "Hidden Tags",
	"mod-topic-log": "View Log",
	"mod-topic-lock-warning": "Are you really sure you want to lock this topic?",
	"mod-topic-soft-delete-warning":
		"Are you really sure you want to delete this topic?",
	"mod-topic-hard-delete-warning":
		"Are you really sure you want to hard delete this topic?\
		This will completely wipe out all posts.  It is irreversible.",

	"mod-topic-lock-title": "Lock Topic",
	"mod-topic-soft-delete-title": "Delete Topic",
	"mod-topic-hard-delete-title": "Hard Delete Topic",

	"mod-topic-lock-pending": "Hold on a sec while I find the key.",
	"mod-topic-delete-pending": "Hold on a sec while I take out the trash.",
	"mod-topic-delete-err-E_NO_PERMISSION":
		"You do not have permission to delete this topic.",
	"mod-topic-delete-err-E_NOT_LOGGED_IN":
		"Ack!  You are no longer signed in.  You'll have to sign in again to delete this topic.",
	"mod-topic-delete-err-E_TOPIC_TOO_LONG":
		"You do not have permission to move long topics. \
		If you wish to move or delete this topic, use the Report Topic functionality to report the \
		topic to site admins.",

	"mod-long-topic-admin-warning":
		"You should not move or delete long topics during class time or \
		when the site is very busy. Are you sure you want to move or delete this?",
	"mod-long-topic-admin-OK": "YES I AM SURE",
	"mod-long-topic-admin-no": "No - do nothing",
	"mod-topic-set-announce-through":
		"Last date of announcement (leave blank for none):",

	"mod-topic-move-title": "Move Topic",
	"mod-topic-move-input-heading": "Move To: ",
	"mod-topic-move-quick": "Quick move: ",
	"mod-topic-move-in-progress": "Moving crew at work, hold on a minute.",
	"mod-topic-move-err-E_NO_PERMISSION":
		"You do not have permission to move this topic.",
	"mod-topic-move-err-E_NOT_LOGGED_IN":
		"Ack!  You are no longer signed in.  You'll have to sign in again to move this topic.",
	"mod-topic-move-err-E_NO_MOVE_TO_LOCKED":
		"Your target forum is locked. The topic has not been moved.",
	"mod-topic-move-err-E_ALREADY_MOVED":
		"Someone just beat you to it!  They already moved this topic.  I won't ruin the suspense and tell you where they moved it.  Hit refresh to find out!",
	"mod-topic-move-err-E_MAX_ANNOUNCEMENTS":
		"Sorry, your target forum already has the maximum number of announcements.",
	"mod-topic-move-err-E_TOPIC_TOO_LONG":
		"You do not have permission to move or delete long topics. \
		If you wish to move or delete this topic, use the Report Topic functionality to report the \
		topic to site admins.",
	"mod-topic-announce-err-E_NO_PERMISSION":
		"You do not have permission to change the announce status of this topic.",
	"mod-topic-announce-err-E_MAX_ANNOUNCEMENTS":
		"Sorry, this forum already has the maximum number of announcements.",
	"mod-topic-announce-err-E_NOT_LOGGED_IN":
		"Ack!  You are no longer signed in.  You'll have to sign in again to change the announcement status of this topic.",
	"mod-topic-remove-target-confirm":
		"Are you sure you wish to remove the link between this topic \
		 and an object on the site? ",
	"mod-topic-remove-target-extra":
		"This operation will also remove all hidden tags, so you will have to \
		 re-add any hidden tags you wish to keep.",
	"mod-topic-remove-target-with-text":
		"Are you sure you wish to remove the link between this topic and {0}? ",
	"mod-topic-remove-target-blocker":
		"Hold on while I take care of this target for you.  Back in a sec.",
	"mod-topic-edit-target-instructions":
		'Edit the target URL by entering the new target below.  When a topic \
		already has a target, I\'ll give you that URL as a hint.  Please make sure you know what you \
		are doing before using this.  Richard will make you do 10 push-ups if you screw up here. Note: \
		a restricted tag is one that has permissions attached.  Think "discussions attached to solutions \
		to homework problems." <b>Entering a blank URL here will not delete the current target.</b> \
		This operation will also remove all hidden tags, so you will have to \
		 re-add any hidden tags you wish to keep.',
	"mod-topic-edit-target-url": "New Target:",
	"mod-topic-edit-target-text": "New Target Descriptor:",
	"mod-topic-edit-target-is-restricted": "Check if target is restricted:",
	"mod-topic-hidden-tag-instructions":
		"Enter text below.  Make sure you know what you're doing \
		before using this.  Or maybe shortly after using this.",
	"mod-topic-hidden-tag-text": "Tag text: ",
	"mod-topic-hidden-tag-is-restricted": "Check if tag is restricted: ",
	"mod-topic-hidden-tag-blocker": "Adding tag; back in a sec...",
	"mod-topic-no-state-tags": "You cannot add state tags here.",
	"mod-topic-announce-blocker": "Setting announcement status of this topic.",

	/** Topics List **/
	"topics-list-no-more-items": "No more topics!",
	"topics-list-no-items-at-all": "No topics here!",
	"topics-list-no-more-items-office-hours-default": "",
	"topics-list-no-more-items-office-hours": "No more topics!",
	"topics-list-no-items-at-all-office-hours":
		"No topics here! Remember to click 'Done Halping' before leaving the page.",
	"topics-list-no-more-privates": "No more private messages.",
	"topics-list-no-privates": "No private messages here!",
	"topics-list-nothing-bookmarked": "Nothing bookmarked!",

	/** Topic Cell **/
	"topic-cell-moved-topic":
		"THIS TOPIC HAS MOVED; CLICK HERE TO GO TO ITS NEW LOCATION.",
	"topic-cell-recycled-topic":
		"THIS TOPIC HAS BEED DELETED; CLICK HERE TO VIEW IN RECYCLE BIN.",
	"topic-cell-reading-now": "Reading now: ",
	"topic-cell-reply": "reply",
	"topic-cell-replies": "replies",
	"topic-cell-no-replies": "0 replies",
	"topic-cell-title-close": "Close topic",
	"topic-cell-title-settle": "Settle reports",
	"topic-cell-title-jump-end": "Jump to end of topic",
	"topic-cell-title-unread": "Jump to first unread",
	"topic-cell-source": "Source",
	"topic-cell-Posted-at":
		'Posted by <a data-cmty title="{2}" href="/community/user/{1}"><b>{0}</b></a> on',
	"topic-cell-1-reader": "{0} user reading this topic.",
	"topic-cell-not-1-reader": "{0} users reading this topic.",
	"topic-cell-visit-in-forum": "Visit this topic in its forum",
	"topic-cell-view-user-profile": "View user profile",

	/* Topic full messages */
	"topic-full-bookmark-tooltip": "Bookmark this (subscribe)",
	"topic-full-remove-bookmark-tooltip": "Remove from bookmarks (unsubscribe)",
	"topic-full-locked-tooltip": "Topic locked",
	"topic-full-locked-forum-tooltip": "Topic's forum is locked",
	"topic-full-reply-tooltip": "Reply to this topic",
	"topic-full-expand-tooltip": "Expand/collapse topic",
	"topic-full-close-tooltip": "Close topic",
	"topic-full-moderate-tooltip": "Moderate topic",
	"topic-full-reply": "Reply",
	"topic-full-locked": "Locked",
	"topic-full-post-reply": "Quick Reply",

	"topic-full-message-deleted":
		"The topic you are viewing has just been deleted.",
	"topic-full-deleted-extra":
		" Since you are in the middle of writing a new post, I will give you \
		a chance to copy your work from the textarea below. After you close this dialog box, the page will \
		reload and you will have to restart your new post.<br><br>",
	"topic-full-deleted-loss-permission":
		"You do not have permission to view this topic anymore.",
	"topic-full-deleted-not-logged-in":
		"You do not have permission to view this topic anymore.  This may be because you are no longer signed in.",
	"topic-full-just-locked": "Sorry!  This topic has just been locked!",
	"topic-full-undelete-title": "Undelete Post",
	"topic-full-new-reply-blocker": "Sending reply... Back soon.",
	"topic-full-reply-confirm": "Are you sure you want to quit your reply?",
	"topic-full-reply-confirm-OK": "Yes",
	"topic-full-reply-confirm-cancel": "No",
	"topic-full-edit-confirm": "Are you sure you want to quit editing?",
	"topic-full-edit-confirm-OK": "Yes",
	"topic-full-delete-post-pending":
		"Hold on a sec while I take out this trash...",
	"topic-full-undelete-message":
		"Are you sure you want to undelete this message?",
	"topic-full-already-reported":
		"This post has already been reported.  A community administrator will address the report soon.",
	"topic-full-already-reported-title": "Post already reported.",
	"topic-full-report-not-logged-in": "You must be signed in to report a post.",
	"topic-full-report-post-title": "Report post",
	"topic-full-report-report-sent":
		"Your report has been filed; a moderator will take a look at it soon.",
	"topic-full-report-item-spam":
		"Spam: Inappropriate conduct, advertising, or some other nonsense.",
	"topic-full-report-item-warez":
		"Warez: Shares copyrighted content without permission.",
	"topic-full-report-item-cheat":
		"Possible cheating: posted problem comes from an active contest, homework, etc.",
	"topic-full-report-item-other": "Other: Please include reason below.",
	"topic-full-settle-report-title": "Settle report",
	"topic-full-unregistered-reply":
		"You must be signed in to make a reply to this topic.",
	"topic-full-reply-to-locked":
		"Sorry, this topic has just been locked, so you cannot reply.",
	"topic-full-reply-to-forum-locked":
		"Sorry, this topic's forum has just been locked, so you cannot reply.",
	"topic-full-locked-tooltip-mod":
		"Topic locked, but you can reply\nby clicking here because you are special.",
	"topic-full-locked-forum-tooltip-mod":
		"Topic's forum is locked, but you can reply\nby clicking here because you are special.",
	"topic-full-not-logged-in-reply": "You must be signed in to reply to topics.",
	"topic-full-title-tooltip": "Click to view topic in its own forum,\n",
	"topic-full-post-with-internal-target-url":
		'This topic is linked to <a {2} href="/feed/{1}{0}">{3}</a>.',
	"topic-full-post-with-external-target-url":
		'This topic is linked to <a {2} href="{0}" target="_blank">{3}</a>.',
	"topic-full-post-without-target-url": "This topic is linked to {0}.",
	"topic-full-post-solution-thread":
		"Only students who have viewed the solution can see this topic.",
	"topic-full-target-text-default": "an item on AoPS",
	"topic-full-remove-target": "Click here to unlink this topic.",
	"topic-full-source": "Source",
	"topic-full-state-tooltip": "Click to Toggle\nCurrent topic state: ",
	"topic-full-undelete-hard": "Yikes; someone already hard deleted that post.",
	"topic-full-click-for-tags": "Reveal topic tags",
	"topic-full-no-post-found":
		"Well, that's embarrassing.  I can't find the post you were looking for. \
		I suspect someone just deleted it, but you can still check out the rest of the topic.",
	"topic-edit-locked":
		"Sorry, this topic has just been locked, so you cannot edit this post.",
	"topic-edit-forum-locked":
		"Sorry, this topic's forum has just been locked, so you cannot edit this post.",
	"snipe-option-never": "Never",
	"snipe-option-close": "Close",
	"snipe-option-flyout": "Flyout",
	"snipe-option-not-this-time": "Not This Time",
	"snipe-title": "You've Been Sniped!",
	"snipe-warning-body":
		"Another user has just replied to this topic.  Their\
							comment has been loaded in your browser; you might want to check it out\
							before submitting your reply. <br /><br />\
							&bull; Click <b>Never</b> to stop the warnings on all topics" +
		(AoPS.session.logged_in
			? ". You can turn warnings back on in your profile. "
			: " during this visit. ") +
		"<br>\
							&bull; Click <b>Flyout</b> to change these warnings from pop-ups to flyouts.<br>\
							&bull; Click <b>Not This Time</b> to block warnings only for this topic, and only during this site visit.<br>\
							&bull; Click <b>Close</b> to close this window but keep the warnings coming.<br /><br />\
							<b>Scroll to the bottom of the topic to see the new posts.</b>",
	"snipe-warning-flyout": "Another user has just replied to this topic.",
	"topic-full-edited-1": "This post has been edited ",
	"topic-full-edited-2": " time",
	"topic-full-edited-3": " times",
	"topic-full-edited-4": ". Last edited by ",
	"topic-full-target-tooltip":
		"This topic is about an item on the AoPS site.\nClick here to visit that item.",

	/** Topic List **/
	"topic-list-jump-top": "Jump to First Topic",

	/** Post **/
	"post-direct-link": 'The <a href="{0}">direct link to this post</a> is:',
	"post-direct-click-ip": "Admin: Click For IP",
	"post-direct-loading-ip": "Loading IP",
	"post-number-title": "Get Post URL",
	"post-attachments": "Attachments:",
	"post-unread-tootip": "This post unread prior to this visit.",
	"post-thanked-by": '<span class="aops-font">Y</span> by',
	"post-thank-this": "Give thumbs up",
	"post-unthank-this": "Remove thumbs up",
	"post-nothank-this": "Give thumbs down",
	"post-unnothank-this": "Remove thumbs down",
	"post-user-tooltip-admin": " is a site admin.\nClick to view user profile.",
	"post-user-tooltip-forum-admin":
		" is an admin of this forum.\nClick to view user profile.",
	"post-user-tooltip-mod":
		" is a moderator of this forum.\nClick to view user profile.",
	"post-user-tooltip-regular": "\nClick to view user profile.",

	/** Edit post **/
	"edit-post-reason-heading": "Edit Post Reason",
	"edit-post-reason-info":
		"Enter your reason for editing the post here.  This reason will\
		be displayed with the post.",
	"edit-post-no-post":
		"Sorry, I can't find this post.  Maybe someone just deleted it!",
	"edit-post-no-permission": "You don't have permission to edit this post.",
	"edit-post-nothing-changed":
		"I looked very closely, but nothing has changed!",
	"edit-send-blocker": "Sending edits... Back shortly.",
	"edit-post-no-links":
		"New users are not allowed to post links in the Community.",
	"edit-post-no-images":
		"New users are not allowed to post images in the Community.",
	"edit-post-logged-out-warning":
		"You have been signed out.  To edit this post, \
						you should sign back in. Here is the edited text you submitted, so\
						you can copy/paste it: ",

	/** Delete post **/
	"delete-post-no-permission":
		"You do not have permission to delete this post.",
	"delete-post-not-last-post":
		"You can only delete your own post if it is the last post in the topic. \
		Someone has posted after you, so you cannot delete this post.",
	"delete-post-sniped":
		"You cannot delete the first post of a topic once someone has responded. \
		If you don't see a reply to this post, refresh the browser.  The reply probably just came in.",

	/** New topic / Reply **/
	"new-topic-subject": "Subject",
	"new-topic-tags": "Tags",
	"new-topic-to": "To",
	"new-topic-preview": "PREVIEW",
	"new-topic-close-preview": "CLOSE PREVIEW",
	"new-topic-post-anon":
		"Post anonymously (instructors will still know who posted)",
	"new-topic-refresh-preview": "REFRESH",
	"new-topic-not-logged-in":
		"You must be signed in to AoPS in order to start a new topic.",
	"new-topic-are-sure": "Are you sure you want to quit your new topic?",
	"new-topic-confirm-cancel": "No!",
	"new-topic-confirm-OK": "Yes! Close the window.",
	"new-topic-title-too-short":
		"Your title is too short; it must be at least " +
		AoPS.Community.Constants.min_topic_title_length +
		" characters.",
	"new-topic-title-too-long":
		"Your title is too long; it must be at most " +
		AoPS.Community.Constants.max_topic_title_length +
		" characters.",
	"new-topic-post-too-short":
		"Your post is too short; it must be at least " +
		AoPS.Community.Constants.min_post_length +
		" characters.",
	"new-topic-post-too-long-python":
		"Your post is too long.  Unfortunately, rendering Python \
		nicely requires adding a bunch of markup to your post; that extra markup is causing your \
		post to be too long.  Try a shorter program.",
	"new-topic-post-too-long":
		"Your post is too long; please trim it down a bit.",
	"new-topic-remove-link-confirm":
		"If you remove this tag, then this topic will not \
		be linked to a particular item and will not appear in the page feed on any page. \
		 The topic will still be posted in the forum <b>{0}</b>.  Is it still OK to delete the tag?",
	"new-topic-send-blocker": "Sending new topic...  Back shortly.",
	"new-pm-send-blocker": "Sending private message.  Back soon.",
	"new-blog-post-send-blocker": "Sending new blog post.  Back soon.",
	"new-topic-post-as-sheriff": "PM as AoPS Sheriff",
	"new-topic-banned-term":
		"You have used a banned term.  Please edit and resubmit.",
	"new-topic-no-links":
		"New users are not allowed to post links in the Community.",
	"new-topic-no-images":
		"New users are not allowed to post images in the Community.",
	"new-topic-invalid-character":
		"You have used a weird character that I don't understand.\
		For example, the AoPS people didn't teach me about those wacky Emoji symbols because \
		some browsers can't handle them.",
	"new-topic-no-tags-message":
		"You have not added any tags to your new topic.\
		Tags help people find your post.  Are you sure you want to post a new topic without tags?",
	"new-topic-no-tags-confirm-yes": "Post without tags",
	"new-topic-no-tags-confirm-no": "Add tags",
	"new-topic-category-deleted": "Sorry, this forum has just been deleted!",
	"new-topic-no-permission":
		"You do not have permission to post new topics in this forum.",
	"new-pm-no-permission":
		"You do not have permission to send new private messages.",
	"new-pm-no-permission-limited":
		'You have a limited account, so you cannot send private messages. \
		You can upgrade your account for free <a href="/user/upgrade.php">here</a>.',
	"new-topic-timeout":
		"Sorry, the call to the server timed out.  There's a good chance your post\
		was saved before I gave up, though.  So, here's what I recommend.  Close this warning, then\
		copy your post.  Then refresh the window and navigate to where you expect to see your post. \
		If the post is not there, then try posting again.",
	"new-topic-err-E_NEW_USER_NEW_TOPIC_LIMITED":
		"New users may only post 3 new topics every 24 hours. \
		This restriction will be lifted after you have been a member of the AoPS Community for 2 weeks.",
	"new-topic-err-E_NEW_VPN_USER_NEW_TOPIC_LIMITED":
		"New users registering from a VPN may only post 1 new topic every 24 hours. \
		This restriction will be lifted after you have been a member of the AoPS Community for 2 weeks.",
	"new-topic-err-E_MAX_ANNOUNCEMENTS":
		"This forum already has the maximum number of \
		allowed announcements. Either post this as a normal topic or remove one of the current \
		announcements before posting.",

	"new-topic-no-category":
		"Uh-oh.  Those AoPS programmers goofed again. \
		Contact tech-support@aops.com to let them know that they forgot to preload a category on this page.  Give them\
		the URL of the page you are on, and tell them which button you clicked to get this message.",
	"new-topic-source-placeholder":
		"Optional.  If posting a problem from a book or contest, enter the source of the problem here",
	"new-topic-pm-archived": "Message sent and archived",
	"new-topic-forum-locked":
		"This forum has been locked.  I'm leaving the new topic window open \
		for you to give you a chance to copy your post.",
	"new-topic-preview-bar-attachments": "VIEW ATTACHMENTS",
	"new-topic-college-tag-warning-title": "College Forum Tag Warning",
	"new-topic-olympiad-tag-warning-title": "Olympiad Forum Tag Warning",
	"new-topic-olympiad-tags-warning":
		"Many people use the tags below to navigate the High School Olympiads forum. \
		We strongly recommend that you add at least one of these tags to your topic.  Click on a tag to add it to your topic.",
	"new-topic-college-tags-warning":
		"Many  people use the tags below to navigate the College Math forum. \
		We strongly recommend that you add at least one of these tags to your topic.  Click on a tag to add it to your topic.",

	"new-topic-denylist-trigger":
		"Sorry, you can't post right now. If you continue having this \
		problem, please send a copy of this note to the site administrator.",
	"new-topic-denylist-text-trigger":
		"Sorry, you can't post right now. Perhaps there is something wrong with your \
		post. If you continue having this \
		problem with other posts, please send a copy of this note to the site administrator.",
	"new-reply-logged-out-warning":
		"You have been signed out.  To post a \
							reply, you should sign back in. Here is the text you submitted, so\
							you can copy/paste it: ",
	"new-reply-no-permission":
		"You do not have permission to reply to this topic.",
	"new-reply-no-permission-limited":
		'You have a limited account, so you cannot post new topics or replies. \
		You can upgrade your account for free <a href="/user/upgrade.php">here</a>.',
	"new-reply-locked":
		"Sorry, the topic was locked right before you submitted your reply!",
	"new-reply-timeout":
		"Sorry, the call to the server timed out.  There's a good chance your post\
		was saved before I gave up, though.  So, here's what I recommend.  Close this warning, then\
		copy your post.  Then refresh the window.  If your post was saved, you should see it when you\
		go to the end of the topic.",
	"new-reply-err-E_NEW_USER_LIMITED":
		"Sorry, but new users may only post 6 times every 24 hours. \
		This restriction will be lifted after you have been a member of the AoPS Community for 2 weeks.",
	"new-reply-err-E_NEW_VPN_USER_LIMITED":
		"Sorry, but new users registering from a VPN may only post 1 time every 24 hours. \
		This restriction will be lifted after you have been a member of the AoPS Community for 2 weeks.",
	"new-reply-err-E_NO_LINK_POSTING":
		"New users are not allowed to post links in the Community.",
	"new-reply-forum-locked":
		"This forum has just been locked, so you cannot reply to this topic.",
	"posting-quote-depth": "You cannot nest more than three quotes.",
	"posting-hide-depth": "You cannot nest more than three hides.",
	"posting-latex-error":
		"You have a LaTeX error in your message.  I have rendered it in red.",
	"posting-asy-error":
		"You have an Asymptote error in your message.  I have rendered it in red.",
	"posting-youtube-error": "You have supplied an invalid YouTube URL.",
	"posting-no-flooding-error":
		"You cannot post so soon after your last post.  Take a break.  Do some push-ups.  Solve an interesting math problem.",
	"error-latex-posting-confirm":
		"You have an error in your {0} code.  I have rendered it in red. \
		You can <b>POST WITH ERROR</b> \
		and hope someone will tell you how to fix it, or you can <b>TRY TO FIX</b> the error yourself.",
	"error-latex-i-will-fix": "TRY TO FIX",
	"error-latex-post-anyway": "POST WITH ERROR",
	"generic-ajax-timeout": "Your request timed out.",

	/** Polymath stuff **/
	"polymath-new-topic-confirm":
		"You are trying to post a new topic in the forum for the MIT PRIMES/AoPS CrowdMath Project.",
	"polymath-force-choice":
		"You must confirm you are a student and indicate that you have read the rules in order to proceed.",
	"polymath-reply-confirm":
		"You are trying to reply to a topic in the forum for the MIT PRIMES/AoPS CrowdMath Project.",
	"polymath-confirm-blocker":
		"Registering you for the Polymath Project.  Please wait a moment.",
	"polymath-confirm-unknown-error":
		"Sorry, there has been an error of some sort.  If this issue persists, please contact tech-support@aops.com, and tell them you received the following code: {0}.",

	/** Private messages **/
	"private-adding-user-blocker": "Adding user to this private message...",
	"private-no-username": "You have not entered a username.",
	"private-from-post": "This message is regarding [url={0}]this post[/url].\n",
	"private-from-post-deleted":
		"This message is regarding the following post, which has been deleted.\n",
	"private-add-user-confirm-OK": "Add",
	"private-add-participant": "Add a user to this conversation",
	"private-need-recipients-err":
		"You must specify some recipients.  You want to be heard, don't you?",
	"private-already-added-active":
		"The user <b>{0}</b> is already included on this private message.",
	"private-already-added-self-removed":
		"The user <b>{0}</b> is already included on this private \
		message, but has chosen not to follow the message anymore. You cannot re-add \
		<b>{0}</b> to this discussion.",
	"private-no-add-self":
		'You are automatically included in any\
			private message you start.   Leave the "To" line blank to talk just to yourself.',
	"private-validation-blocker": "Validating recipient...",
	"private-unreachable-recipient": "Cannot send message to this recipient.",
	"private-category-name": "My Private Messages",
	"private-archived-category-name": "My Archived Private Messages",
	"private-archive-title": "View archived messages",
	"private-View-Archive-btn": "View Archived Messages",
	"private-Archive-btn": "Archive",
	"private-Unarchive-btn": "Unarchive",
	"private-user-removed":
		"This user left the conversation and will not receive replies.",
	"private-remove-me": "Remove me from this conversation.  Forever.  Please.",
	"private-remove-from-archived":
		"Are you sure you wish to be removed from this conversation?  <b>You will\
		not be able to access this message in the future, and will receive no replies to the message.</b>",
	"private-remove-from-active":
		'Are you sure you wish to be removed from this conversation?  <b>You will\
		not be able to access this message in the future, and will receive no replies to the message.</b>\
		You may instead choose to archive this message by first clicking "Cancel", then clicking\
		"Archive" on the message.  This will remove the message from your inbox and place it in your Archive.',
	"private-remove-me-ok": "Remove Me",
	"private-remove-blocker": "Removing you from the conversation.",
	"private-archive-topic": "Archive this conversation",
	"private-unarchive-topic": "Unarchive this conversation",
	"private-message-archived": "Message archived.",
	"private-message-unarchived": "Message unarchived, moved to inbox.",
	"private-message-not-logged-in":
		"When you are signed in to AoPS, you will be able to send messages.",
	"private-reply-no-listeners":
		"Everyone else has left this conversation; no one will see your comment unless you add\
		new participants.",
	"private-user-excluded":
		'The user <b>{0}</b> is not accepting new private messages, \
		so cannot be added to this discussion.  The user has been removed from your "To" list. \
		You must hit <b>Submit</b> again to send.',
	"private-user-sheriff":
		"AoPSSheriff is a system account used to send messages from many \
		different AoPS administrators.  To contact AoPSSheriff about an issue, please email \
		sheriff@aops.com.",
	"private-user-extensions":
		"Extensions is a system account used to send messages from many \
		different AoPS administrators.  To contact Extensions about an issue, please email \
		extensions@aops.com.",
	"private-user-excluded-by-system":
		'The user <b>{0}</b> cannot receive private messages, \
		so cannot be added to this discussion.  The user has been removed from your "To" list. \
		You must hit <b>Submit</b> again to send.',
	"private-new-msg-too-many-participants":
		"You have listed too many recipients.  A private message can have\
		at most " +
		AoPS.Community.Constants.max_conversation_participants +
		" participants, including yourself.",
	"private-cant-add-more":
		"You have reached the maximum number of message participants. \
		A private message can have at most " +
		AoPS.Community.Constants.max_conversation_participants +
		" participants, including yourself.",
	"pm-notify":
		"You have received a new private message, <b>{1}</b>, from <b>{0}</b>.",
	"pm-notify-flyout":
		'You have received a new private message, <b>{1}</b>, from <b>{0}</b>. \
		<a data-cmty href="/community/c1h{2}">Click here to view</a>',
	"pm-notify-title": "New Private Message",
	"pm-notify-btn-OK": "VIEW MESSAGE",
	"pm-notify-btn-cancel": "CLOSE",

	/** Posting attachments **/
	"post-attachments-default":
		"Drag your files here, or <a>click here</a> to select files from your computer.  Max three files per post.",
	"post-attachments-title": "Attach Files",
	"post-attachments-spoofed":
		"I don't trust a file you've attached, so you cannot upload it.",
	"post-attachments-bad-file-type":
		"Sorry, but the file {0} has a file type that I don't like.",
	"post-attachments-no-permission":
		"You do not have permission to post attachments on this site.",
	"post-attachments-already-attached": "Existing Attachments",
	"post-attachments-file-too-big":
		"This file is too large.  The maximum file size is " +
		AoPS.Community.Constants.max_attachment_size +
		"KB.",
	"post-attachments-done": "DONE",
	"post-attachments-invalid-character":
		"Sorry, your file name has an invalid character. \
		The only characters that are allowed are letters, numbers, spaces, dashes, underscores, and periods.",

	/** Page title **/
	"page-title-my-aops": "My AoPS",
	"page-title-reported-posts": "Reported Posts",
	"page-title-search": "Search",

	/** User profile **/
	"user-profile-title": "User Profile",
	"user-profile-browser-title": " User Profile",
	"user-profile-activity": "Activity",
	"user-profile-joined_at": "Joined",
	"user-profile-email": "Email",
	"user-profile-location": "Location",
	"user-profile-status": "Status",
	"user-profile-occupation": "Occupation",
	"user-profile-school": "School",
	"user-profile-goals": "Goals",
	"user-profile-interests": "Interests",
	"user-profile-signature": "Signature",
	"user-profile-friends": "Friends",
	"user-profile-last-visit": "Last Visited",
	"user-profile-total-posts": "Total Posts",
	"user-profile-blog": "Blog",
	"user-profile-website": "Website",
	"user-profile-BANNED": "BANNED",
	"user-profile-LIMITED": "LIMITED",
	"user-profile-add-note": "Adding note; page will reload when finished.",
	"user-profile-COPPA": "COPPA",
	"user-profile-thanks-given": '<span class="aops-font">Y</span> Given',
	"user-profile-thanks-received": '<span class="aops-font">Y</span> Received',
	"user-profile-no-such-user": "No such user!  You asked for user <b>{0}</b>.",
	"user-profile-friend-toggle-off":
		"Your friends are on your public profile. \nClick to hide them from your public profile.",
	"user-profile-friend-toggle-on":
		"Your friends are not on your public profile. \nClick to show them on your public profile.",
	"user-profile-add-friend": "Add Friend",
	"user-profile-friend-request": "Has sent you a friend request.",
	"user-profile-friend-ACCEPT": "ACCEPT",
	"user-profile-friend-DECLINE": "DECLINE",
	"user-profile-no-friends": "No AoPS friends yet.",
	"user-profile-unfriend-confirm":
		"Are you sure you wish to cancel your friendship with <b>{0}</b>?",
	"user-profile-add-friend-instructions":
		"Make a friend request by entering the username of your potential new\
		friend below, and then click OK.<br><br><b>Warning</b>: All your friends can see your Alcumus profile, including your Alcumus statistics.",
	"user-profile-new-friend": "New friend",
	"user-profile-add-friend-modal-title": "Make Friend Request",
	"user-profile-add-friend-title": "Add Friend",
	"user-profile-no-friend-self":
		"No friending yourself!  Choose someone else...",
	"user-profile-add-friend-none-chosen":
		"Either choose a username or click CANCEL, please.",
	"user-profile-request-sent": "Friend request sent to <b>{0}</b>.",
	"user-profile-friend-request-pending": "Sending your friend request.",
	"user-profile-err-no-perm-friend":
		"You do not have permission to make friend requests.",
	"user-profile-err-no-perm-friend-limited":
		"You have a limited account, so you cannot make, accept or decline friend requests. \
		You can upgrade your account for free <a href='/user/upgrade.php'>here</a>.",
	"user-profile-err-already-friend": "You are already friends with <b>{0}</b>.",
	"user-profile-err-they-asked-you":
		"The user <b>{0}</b> has already asked you to be friends, so I went ahead and made the\
		two of you friends.  You should see <b>{0}</b> among your friends if you refresh the page.",
	"user-profile-err-already-asked":
		"You have already asked <b>{0}</b> to be your friend.",
	"user-profile-err-not-taking-requests":
		"The user <b>{0}</b> has left the friends system and is therefore not receiving friend requests.",
	"user-profile-send-request-not-logged-in":
		"When you are signed in to AoPS, you will be able to send friend requests.",
	"user-profile-send-request-check":
		"Send friend request to user <b>{0}</b>?<br><br><b>Warning</b>: Your friends can access your Alcumus profile, including your Alcumus statistics.",
	"user-profile-err-no-request-available":
		"Uh-oh, I couldn't find the friend request from <b>{0}</b>.  That probably means that \
		<b>{0}</b> just opted out of the friends system.",
	"user-profile-friend-request-accepted":
		"Friend request from <b>{0}</b> accepted.",
	"user-profile-friend-request-denied":
		"Friend request from <b>{0}</b> declined.",
	"user-profile-no-my-forums":
		'<b>My Forums</b> consists of forums you have created, forums you moderate or administrate, or private forums you can access. \
			You currently have no such forums.  Once you have some, you can manage the <b>My Forums</b> page by clicking \
			<span class="aops-font cmty-text">3</span> again.',
	"user-profile-no-my-collections":
		'<b>My Collections</b> consists of collections you have created, collections you moderate or administrate, or private collections you can access. \
			You currently have no such collections.  Once you have some, you can manage the <b>My Collections</b> page by clicking \
			<span class="aops-font cmty-text">3</span> again.',
	"user-profile-no-my-blogs":
		'<b>My Blogs</b> consists of blogs you created or contribute to, or private blogs you can access. \
			You currently have no such blogs.  Once you have some, you can manage the <b>My Blogs</b> page by clicking \
			<span class="aops-font cmty-text">3</span> again.',
	"user-profile-click-for-posts": "Click to view posts",
	"user-profile-no-count-note": "*Not included in total",
	"user-profile-no-search-note": "**Forum not searchable",
	"user-profile-pm-title": "Send a private message to this user",
	"user-cell-visit-profile": "Visit user profile",
	"user-bookmark-err-E_ITEM_NUM_LIMITED":
		"Sorry, you have reached the limit of the number of users that can be bookmarked.",
	"user-bookmark-err-E_NOT_LOGGED_IN":
		"Sorry, you have been signed out.  Please sign back in and try again.",

	"friends-warning":
		'<div class="cmty-friends-heading">Friend Requests</div>\
		<b>Warning</b>: All your friends can view your Alcumus profile, including your Alcumus statistics.',
	/** Edit profile **/
	"edit-profile-title": "Edit Profile And Account",
	"edit-profile-profile-info": "Profile Information",
	"edit-profile-edit-avatar": "Edit Avatar",
	"edit-profile-delete-avatar": "Delete Avatar",
	"edit-profile-delete-avatar-confirm":
		"Are you sure you want to delete {0} avatar?",
	"edit-profile-your": "your",
	"edit-profile-this-user": "this user's",
	"edit-profile-new-user":
		"Your account is too new, so you cannot edit your profile. \
		You can only edit your email and password on this page. You will be able to add additional information to your \
		profile, such as a status, once your account is over two weeks old.",
	"edit-profile-limited-user":
		'You currently have a limited account, so you cannot edit your profile. \
		You can only edit your password on this page.  You will be able to edit your profile if \
		you upgrade your account.  You can upgrade your account for free <a href="/user/upgrade.php">here</a>.',
	"edit-profile-coppa-user":
		"The Children's Online Privacy Protection Act (COPPA) requires us to collect parental permission prior to you \
			being able to use your account. You can only edit your email and password on this page. Please check your email for details.",
	"edit-profile-deleting-avatar": "Deleting avatar, back in a sec...",
	"edit-profile-change-password": "Change Password",
	"edit-profile-location-placeholder": "Enter your location.",
	"edit-profile-school-placeholder": "Enter your school.",
	"edit-profile-interests-placeholder": "Enter your interests.",
	"edit-profile-website-placeholder": "Enter your website.",
	"edit-profile-occupation-placeholder": "Enter your occupation.",
	"edit-profile-email-placeholder": "You cannot leave this field blank!",
	"edit-profile-goals-placeholder": "Enter your goals.",
	"edit-profile-status-placeholder": "Enter your status.",
	"edit-profile-inappropriate-term":
		"Inappropriate language used when setting <b>{0}</b>. \
		This field has been reset to its original value.",
	"edit-profile-unknown-error":
		"Unknown error occurred when setting <b>{0}</b>. \
		The error code is <b>{1}</b>.",
	"edit-profile-email-not-available":
		"The email address <b>{0}</b> is already attached to another\
		username.  Each email address can be associated with only one user.",
	"edit-profile-current-password": "Current Password",
	"edit-profile-new-password": "New Password",
	"edit-profile-retype-password": "Confirm Password",
	"edit-profile-invalid-common-password":
		"Sorry, you have selected a new password that is too common.  Please select a different one.  Your password has not been reset yet.",
	"edit-profile-retype-password-placeholder": "Enter your new password again.",
	"edit-profile-new-password-placeholder": "Enter your desired new password.",
	"edit-profile-current-password-placeholder": "Enter your current password.",
	"edit-profile-passwords-dont-match":
		"Confirm password does not match new password.",
	"edit-profile-enter-password": "You must enter your current password.",
	"edit-profile-submit-new-password": "Validating new password...",
	"edit-profile-invalid-password":
		"The current password you entered is not correct.  Please try again.",
	"edit-profile-password-changed": "Password changed!",
	"edit-profile-password-too-short":
		"New password is too short.  It must be at least " +
		AoPS.Community.Constants.min_password_length +
		" characters.",
	"edit-profile-email-not-valid":
		"New email is not a valid email address.  No change made.",
	"edit-profile-email-in-use": "This email is in use by a different user.",
	"edit-profile-email-rate-limit":
		"An email change has been recently requested. Please check your email.",
	"edit-profile-email-not-changed":
		"New email is the same as the old one.  No change needed.",
	"edit-profile-new-email":
		"A confirmation email has been sent to your requested new address, <b>{0}</b>. \
		Until you confirm this new address, the email address associated with this account will remain <b>{1}</b>.",
	"edit-profile-email-change-title": "Change Email",
	"edit-profile-email-change=blocker": "Submitting new email address...",
	"edit-profile-no-perm": "You do not have permission to edit your profile.",
	"edit-profile-not-logged-in":
		"You are not signed in.  You have to sign in to edit your profile.",

	/** New Users **/
	"new-user-my-forums":
		"  New users may create new forums after being members of the AoPS Community for at least two weeks.",
	"new-user-my-blogs":
		" New users may create new blogs after being members of the AoPS Community for at least two weeks.",
	"new-user-my-collections":
		" New users may create new collections after being members of the AoPS Community for at least two weeks.",

	/** Edit Avatar **/
	"edit-avatar-file-too-big":
		"This file is too large.  The maximum file size is " +
		AoPS.Community.Constants.max_avatar_file_size +
		"KB.",
	"edit-avatar-default-message":
		"Drag your new avatar here, or <a>click here</a> to select a file on your computer.",
	"edit-avatar-dimensions-too-big":
		"This image's dimensions are too big.  The width and height must both be \
		no more than 100px.",
	"edit-avatar-bad-file-type": "Sorry, we only take JPG and PNG image files.",
	"edit-avatar-bad-file-type-apng":
		"Sorry, we do not accept animated PNG image files.",
	"edit-avatar-too-many": "Whoa!  You should only send one file!!",
	"edit-avatar-no-file":
		"Um, I think you forgot something.  I didn't receive a file.",
	"edit-avatar-no-permission":
		"You do not have permission to change this avatar.",
	"edit-avatar-title": "Upload Avatar",

	/** Search **/
	"search-page-title": "Advanced Community Search",
	"search-page-private-title": "Private Message Search",
	"search-results-title-with-text": "for {0}",
	"search-results-edit": "Edit search settings",
	"search-err-no-such-user":
		"Sorry, I don't know any user with the username <b>{0}</b>.",
	"search-err-no-such-forum":
		"Sorry, we don't have a forum with the name <b>{0}</b>.",
	"search-validation-blocker": "Validating search parameters...",

	/** User search **/
	"user-search-posts-category-username": "Posts by {0}",
	"user-search-posts-category-user-id": "Posts by the User with Id {0}",

	/** Edit Community Settings **/
	"edit-settings-page-title": "Edit Community Settings",
	"edit-settings-general-heading": "General Settings",
	"edit-settings-friends-heading": "Friends",
	"edit-settings-posting-heading": "Posting and Reading",
	"edit-settings-feed-heading": "Feed",
	"edit-settings-pm-heading": "Private Messages",
	"edit-settings-hidden-label": "Hide my online status",
	"edit-settings-hide_feed-label": "Hide the feed",
	"edit-settings-show_tags_on_feed-label": "Show tags in the feed",
	"edit-settings-global_feed_type-label": "Global Feed type",
	"edit-settings-enable_advanced_hotkeys-label":
		'Enable <a href class="cmty-advanced-hotkeys">Advanced Hotkeys</a>',
	"edit-settings-friends_show_profile-label":
		"Show my friends on my public profile",
	"edit-settings-friends_exclude-label":
		"Exclude me from the friends system (and delete all my existing friendships)",
	"edit-settings-posting_subscribe_new_topic-label":
		"Email me upon replies to any topic I start",
	"edit-settings-posting_subscribe_reply-label":
		"Email me upon replies to any topic I reply to",
	"edit-settings-posting_fullscreen_reply-label":
		"Always use full reply (except in feed)",
	"edit-settings-hide_avatars-label": "Hide user avatars on posts and topics",
	"edit-settings-hide_tags_on_topic-label": "Hide the tags on topics",
	"edit-settings-pm_email-label":
		"Email me whenever anyone sends me a private message",
	"edit-settings-pm_archive_on_send-label":
		"Archive new private messages I send (not replies; only new topics)",
	"edit-settings-pm_live_notify-label":
		"Notification method when I receive a private message when I am logged in to AoPS",
	"edit-settings-pm_exclude_self-label":
		"Prevent users from sending me new private messages (Admins will still be able to send you messages, and users\
		can reply to existing messages)",
	"edit-settings-warn_on_snipes-label":
		"Warning type when a new reply comes in for a topic while I'm typing a reply to topic.",
	"edit-settings-forum_view-label":
		"Topic cell view style when browsing topics (page will reload on change)",
	"edit-settings-turn_off_autotagging-label":
		"Turn off autotagging for new topics I post",
	"edit-settings-archive-pm-btn": "Archive All",
	"edit-settings-remove-from-pm-btn": "Remove All",
	"edit-settings-archive-pm-label": "Archive all private messages",
	"edit-settings-remove-from-pm-label":
		"Remove self from all existing private messages \
		 (you will not be able to access the messages again)",
	"edit-settings-privates-archived": "All private messages archived",
	"edit-settings-archive-confirm":
		"Are you sure you want to archive all of your private messages? \
		You will still be able to access them in your private messages archive.",
	"edit-settings-remove-confirm":
		"Are you sure you want to remove yourself from all of your private \
		messages?  This is irreversible; you will not be able to access the messages in the future, \
		though the other participants in each message will still be able to access them. You will \
		be removed from the messages in both your inbox and your private message archive.",
	"edit-settings-privates-removed":
		"You have been removed from all of your private messages.",
	"edit-settings-hotkeys-modal-title": "Advanced Hotkeys",
	"edit-settings-no-friends-confirm":
		"Are you sure you want to remove yourself from the friends system? \
		All of your existing friendships will be deleted. They will be reinstated if you return to the friends system.",
	"edit-settings-no-friends-confirm-title": "Leave Friends System?",
	"edit-settings-main-base-view": "Main",
	"edit-settings-portal-base-view": "Portal",
	"edit-settings-base_view-label":
		'Home page for community (<a data-cmty href="/community/main">Main</a> \
		is the primary view of the community, and <a data-cmty href="/community/portal">Portal</a> is the Olympiad &amp; College Portal.)',
	"edit-settings-please-wait-bkmk":
		"Hold on a sec...  The page will reload when I'm finished \
		cleaning your bookmarks.",
	"edit-settings-bkmk-all-confirm":
		"Are you sure you want to delete all {0} from your bookmarks?  This \
		will remove all {0} from your feed and unsubscribe you from all {0}.",
	"edit-settings-bkmk-feed-confirm":
		"Are you sure you want to delete all bookmarked {0} from your feed? \
		These {0} will still be in your bookmarks, and your email subscriptions will not be changed.",
	"edit-settings-bkmk-email-confirm":
		"Are you sure you want to unsubscribe from all email notifications \
		about your currently bookmarked {0}? These {0} \
		will still be in your bookmarks, and your bookmark feed will be unchanged.",
	"edit-settings-bkmk-heading": "Bookmarked {0}",
	"edit-settings-bkmk-link-all": "Delete All",
	"edit-settings-bkmk-link-feed": "Empty Feed",
	"edit-settings-bkmk-link-email": "Unsubscribe",
	"edit-settings-bkmk-all-label": "Delete all {0} from your bookmarks.",
	"edit-settings-bkmk-feed-label": "Remove all {0} from your feed.",
	"edit-settings-bkmk-email-label":
		"Unsubscribe from all {0}. (End email notification.)",

	/** Add participants **/
	"add-participant-instructions-start":
		"Enter a username below to add someone to this message.\
			The new participant will be able to read the entire\
			thread, including posts that occurred before the new participant was\
			added to the discussion.  Also, each private\
			message can have no more than",
	"add-participant-instructions-end": "participants.",
	"add-participant": "Add participant",
	"add-participant-add-user": "Add user:",
	"add-participant-placeholder": "Enter username",
	"add-participant-logged-out":
		"You have been signed out.  You will have to sign\
		back in and try again.",
	"add-participant-no-permission":
		"You do not have permission to add a participant\
		to this discussion.",
	"add-participant-removed-user":
		"This user chose to leave this conversation and cannot\
		 be re-added.",
	"add-participant-to-sheriff":
		"You cannot add a participant to a private message from the AoPS Sheriff.",
	"add-participant-to-extensions":
		"You cannot add a participant to a private message from Extensions.  If you have an \
		issue regarding extensions, please email extensions@aops.com.",
	"add-participant-too-late":
		"You waited too long!  It is now past the time limit \
		to add a user to this discussion.",
	"add-participant-no-more":
		"Someone beat you to it!  This private message now has \
		the maximum allowed number of participants.",
	"add-participant-no-self": "You cannot add yourself to a private message!",
	"add-participant-recipient-exclude-self":
		"The user <b>{0}</b> is not accepting new private messages, \
		so cannot be added to this discussion.",
	"add-participant-recipient-sheriff":
		"AoPSSheriff is a system account used to send messages from many \
		different AoPS administrators.  You cannot add the AoPSSheriff to a private message. \
		To contact AoPSSheriff about an issue, please email sheriff@aops.com. ",
	"add-participant-recipient-extensions":
		"Extensions is a system account used to send messages from many \
		different AoPS administrators.  You cannot add Extensions to a private message. \
		To contact Extensions about an issue, please email extensions@aops.com. ",
	"add-participant-recipient-exclude-system":
		"The user <b>{0}</b> cannot receive private messages, \
		so cannot be added to this discussion.",

	/** Polls **/
	"poll-question": "Poll Question",
	"poll-options": "Poll Options",
	"poll-options-desc":
		"Place each option on a new line.  Enter up to 20 options.",
	"poll-options-per": "Options Per User",
	"poll-length": "Poll Length",
	"poll-unlimited": "Unlimited",
	"poll-len-1-day": "1 day",
	"poll-len-2-days": "2 days",
	"poll-len-3-days": "3 days",
	"poll-len-1-week": "1 week",
	"poll-len-2-weeks": "2 weeks",
	"poll-len-1-month": "1 month",
	"poll-revoting": "Allow Revoting?",
	"poll-cancel": "CANCEL POLL",
	"poll-cancel-title": "Cancel Poll?",
	"poll-cancel-confirm":
		"Are you sure that you want to cancel this poll?\
		Canceling the poll only removes the poll options.  It does not\
		cancel the whole topic window.",
	"poll-cancel-no": "DON'T CANCEL",
	"poll-no-question-error":
		"You must include a Poll Question when posting a poll.",
	"poll-no-inputs-error":
		"You must include some options for the voters to choose from in your poll.",
	"poll-question-too-short":
		"Your poll question is not long enough.  It must be at least " +
		AoPS.Community.Constants.min_poll_question_length +
		" characters.",
	"poll-question-too-long":
		"Your poll question is too long.  It must no more than " +
		AoPS.Community.Constants.max_poll_question_length +
		" characters.",
	"poll-display-heading": "Poll:",
	"poll-Vote": " Vote",
	"poll-Votes": " Votes",
	"poll-select-one": "Select <b>{0}</b> option.",
	"poll-select-many": "Select up to <b>{0}</b> options.",
	"poll-revote-btn": "CHANGE VOTE",
	"poll-vote-btn": "VOTE",
	"poll-hide-results": "Hide Results",
	"poll-loading": "Loading poll details...",
	"poll-show-results": "Show Results",
	"poll-not-logged-in": "You must be signed in to vote.",
	"poll-not-initialized":
		'You must <a onClick="AoPS.Initialize.display({escapable: true});">set up your account</a> to vote.',
	"poll-needs-coppa-approval":
		"The Children's Online Privacy Protection Act (COPPA) requires us to collect parental permission prior to you being able to use your account. Please check your email for details.",
	"poll-is-limited-user":
		'You have a limited account, so you cannot use this poll. \
		You can upgrade your account for free <a href="/user/upgrade.php">here</a>.',
	"poll-nothing-selected":
		"Work with me here.  You have to choose something to vote!",
	"poll-revote-directions":
		"You have already voted, but are allowed to change your vote.  To change your\
		vote, make a new selection and click CHANGE VOTE above.",
	"poll-vote-processing":
		"Recording your vote and tabulating new results.  Back in a sec!",
	"poll-err-not-logged-in":
		"You are not signed in.  You must be signed in to vote.",
	"poll-err-closed": "Sorry, but the poll closed while you were voting!",

	/** New item (editable item stuff, like tagboxes **/
	"new-item-too-short":
		"Your entry is too short; it must be at least 2 characters.",
	"new-item-already-added": "You have already added ",
	"new-item-too-many-1": "You can only have ",
	"new-item-too-many-2": "s. You'll have to delete some to add new ones.",

	/** Posting environ extra options **/
	"post-environ-extra-announce": "Make announcement",
	"post-environ-global-announce": "Make global announcement",
	"post-environ-announce-through": "Announce through:",
	"post-environ-invalid-announce-date":
		"Invalid announcement end date.  The date must be in yyyy-mm-dd format.",
	"post-environ-announce-date-too-early":
		"The last date of the announcement cannot be in the past!  Please try again.",
	"post-environ-announce-date-too-late":
		"The last date of the announcement cannot be more than 2 years in the future.  (Leave date field blank for permanent announcements.)",
	"post-environ-image-error":
		"Sorry, there is something wrong with one of your img tags.  You \
		may have entered in an invalid URL, or you might be using the tag incorrectly.  Please \
		read your post closely and try again.",
	"post-environ-tip-error":
		"Sorry, there is something wrong with one of your tags.  The \
		content of tips cannot be empty.",

	/** bbcode titles **/
	"bbcode-title-bold": "Bold text\n[b]text[/b]",
	"bbcode-title-underline": "Underline text\n[u]text[/u]",
	"bbcode-title-italic": "Italic text\n[i]text[/i]",
	"bbcode-title-text-size":
		"Text size\n[size=NUMBER FROM 50 TO 200]text[/size]",
	"bbcode-title-text-color": "Text color\n[color=#HEX COLOR CODE]text[/color]",
	"bbcode-title-quote":
		"Quote text\n[quote]quoted text[/quote] -or-\n[quote=<person quoted>]quoted text[/quote]",
	"bbcode-title-list":
		"List\n[list]Your list here, each item on its own line[/list]",
	"bbcode-title-hide":
		"Hide text\n[hide]hidden text[/hide] -or-\n[hide=<text for the link>]hidden text[/hide]",
	"bbcode-title-code":
		"Code formatting\n[code]code[/code] -or-\n[code=<language>]code[/code]",
	"bbcode-title-smiley": "Smileys!",
	"bbcode-title-img": "Image\n[img]image url[/img]",
	"bbcode-title-url":
		"Link\n[url]<your URL>[/url] -or-\n[url=<your URL>]text for link[/url]",
	"bbcode-title-attachment": "Add an attachment",
	"bbcode-title-has-attachments": "Attachments:",
	"bbcode-title-poll": "Start a poll",

	/** View Posts **/
	"view-posts-click-hidden": "Click to reveal hidden content",

	/** Post Report Admin **/
	"post-report-admin-reported-by": "Reported by",
	"post-report-admin-reported-date": "When",
	"post-report-admin-details": "Details",
	"post-report-admin-for": "For",
	"post-report-admin-confirm":
		"Are you sure you want to resolve this post report?\
		If so, you can add notes about the report resolution below.",
	"post-report-admin-confirm-title": "Resolve Post Report",
	"post-report-admin-block":
		"Hold on a sec; sending your resolved post report to the database.",
	"post-report-admin-page-title": "Reported Posts",
	"post-report-admin-loading":
		"Hold on a sec, I'm going to see if there are any more reports\
		for you.",
	"post-report-no-more": "No more reported posts.",
	"post-report-admin-none": "No reported posts found.",
	"post-report-admin-notes": "Notes",
	"post-report-admin-no-permission":
		"You do not have permission to resolve this post report.",
	"post-report-admin-page-text":
		"On this page are the reported posts in the forums\
		you moderate and the blogs you administrate.  If you reached this page by clicking a report notification on a post or topic,\
		but you see no report here, then someone else has beaten you to it!  When you return to the\
		topic, the notification for that post should no longer appear.",
	"post-report-first-post-note":
		"<b>Note:</b> This post is the first post in its topic, so\
		you cannot simply delete this post. \
		Please visit the topic by clicking the topic title, to determine whether or not you\
		should delete the whole topic.",
	"post-report-admin-pm": "PM",
	"post-report-admin-pm-poster": "Poster",
	"post-report-pm-subject": "Response to Report",
	"post-report-pm-reporter-preamble":
		"This message is regarding your report of [url={0}]this post[/url].",
	"post-report-admin-pm-reporter": "Reporter",
	"post-report-pm-reporter":
		"You submitted the following details in your report:",
	"poll-too-many-selected":
		"You have chosen too many options.  You can only choose up to <b>{0}</b> options.",
	/** Tagbox **/
	"tag-edit-title": "Edit tags",
	"autocomplete-new-tag": "No tags match.<br>Press Enter to create tag.",

	/** My AoPS page **/
	"my-aops-Community-Settings": "Edit Community Settings",
	"my-aops-Edit-Profile": "Edit Profile and Account",
	"my-aops-MyForums": "My Forums",
	"my-aops-MyCollections": "My Collections",
	"my-aops-MyBlogs": "My Blogs",
	"my-aops-MyBooks": "My Books",
	"my-aops-MyClasses": "My Classes",
	"my-aops-phone-PM": "PM",
	"my-aops-phone-Bkmk": "Bkmk",
	"my-aops-phone-Fora": "Fora",
	"my-aops-phone-Coll": "Coll.",
	"my-aops-phone-Blogs": "Blogs",

	/** Category Admin **/
	"cat-admin-general-info": "General Information",
	"cat-admin-description-heading": "Description",
	"cat-admin-in-global-feed": "In Global Feed",
	"cat-admin-global-feed-help":
		'(See the Feeds section of <a data-cmty href="/community/faq">Community Help</a> for more information.)',
	"cat-admin-create-button": "CREATE",
	"cat-admin-soft-delete": "Soft Delete",
	"cat-admin-delete": "Delete",
	"cat-admin-hard-delete": "Hard Delete",
	"cat-admin-reported-posts": "Reported Posts",
	"cat-admin-global-automatic":
		"(Class forums are always included in the Global Feed.)",
	"cat-admin-global-err-E_ALL_GLOBAL_FORA_REMOVED":
		"You have removed all forums from \
		your global feed, so you will have your global feed reset to the default set of forums.",
	"cat-admin-global-err-E_NOT_VALID_FORUM":
		"Sorry, this category is not a forum \
		and cannot be added to the global feed.",
	"cat-admin-global-err-E_CLASS_FORA_ALWAYS_IN_GLOBAL":
		"All class forums are automatically \
		added to the global feed.",
	"cat-admin-global-err-E_NOT_LOGGED_IN":
		"You are no longer signed in.  No change made.",
	"cat-admin-global-err-E_GLOBAL_SET_TO_FULL":
		"Your global feed is currently set to \
		the full feed, so you cannot customize it.  Edit your Community Settings in the \
		My AoPS page to switch to a custom global feed.",
	"cat-admin-global-err-E_TOO_MANY_FEED_FORA":
		"Sorry, you have reached the limit \
		of the number of forums you can have in your global feed.  The limit is currently \
		75 forums.",

	"cat-admin-view-log": "View Category Log",
	"cat-admin-delete-blocker":
		"Deleting now; you will be redirected to the Community homepage when I am finished.",
	"cat-admin-soft-delete-confirm":
		"Do you really want to delete <b>{0}</b>? This action \
		is not reversible!",
	"cat-admin-delete-protected": "This is protected; it cannot be deleted.",
	"cat-admin-delete-not-found":
		"Someone beat you to it.  This has already been deleted.",
	"cat-admin-delete-no-permission":
		"You do not have permission to delete this.",
	"cat-admin-hard-delete-confirm":
		"Do you really want to <b>HARD</b> delete <b>{0}</b>? This action \
		is impossible to revert, as it deletes entries from the database entirely.",
	"cat-admin-cat-name-warning":
		'NOTE: Forum and collection names must be unique.  If you choose a name that \
		site admins need later, such as "2023 IMO", then we\'ll ask you to change the name at that time.',
	"cat-admin-create-public-forum-warning":
		"You have marked this forum <b>public</b>. Any registered\
		users will be able to read, post, and reply in this forum.  You cannot\
		change this forum to private once you have created it.  Are you sure you want to create this\
		forum as <b>public</b>?",
	"cat-admin-create-private-forum-warning":
		"You have marked this forum <b>private</b>. Only users\
		who are granted permission to access this forum, and AoPS administrators, will be able to\
		access this forum.  You cannot\
		change this forum to public once you have created it.  Are you sure you want to create this\
		forum as <b>private</b>?",
	"cat-admin-create-public-collection-warning":
		"You have marked this collection <b>public</b>. Any registered\
		users will be able to access this collection.  You cannot\
		change this collection to private once you have created it.  Are you sure you want to create this\
		collection as <b>public</b>?",
	"cat-admin-create-private-collection-warning":
		"You have marked this collection <b>private</b>. Only\
		you and AoPS administrators will be able to\
		access this collection.  You cannot\
		change this collection to public once you have created it.  Are you sure you want to create this\
		collection as <b>private</b>?",
	"cat-admin-create-public-blog-warning":
		"You have marked this blog <b>public</b>. Any registered\
		users will be able to read, shout, and reply in this blog.  Are you sure you want to create this\
		blog as <b>public</b>?",
	"cat-admin-create-private-blog-warning":
		"You have marked this blog <b>private</b>. Only users\
		who are granted permission to access this blog, and AoPS administrators, will be able to\
		access this blog.  Are you sure you want to create this\
		blog as <b>private</b>?",
	"cat-admin-forum-name-too-short":
		"Your Forum Name is too short.  It must have at least 3 characters.",
	"cat-admin-blog-name-too-short":
		"Your Blog Name is too short.  It must have at least 3 characters.",
	"cat-admin-collection-name-too-short":
		"Your Collection Name is too short.  It must have at least 3 characters.",
	"cat-admin-create-category-blocker": "Hold on a sec while I build this!",
	"cat-admin-back-to-class": "CLASS",
	"cat-admin-back-to-cmty": "COMMUNITY",
	"cat-admin-label-include_in_count": "Include in Post Count",
	"cat-admin-label-include_in_thank_count":
		'Include in <span class="aops-font">Y</span> Count',
	"cat-admin-label-include_in_nothank_count":
		'Include in <span class="aops-font">_</span> Count',
	"cat-admin-label-include_in_dynamic_collections": "Include in Dynamic Coll.",
	"cat-admin-admin-item-warning":
		"Admin-only items; only edit these if you know what you are doing.",

	"cat-admin-forum-name": "Forum Name",
	"cat-admin-forum-name-placeholder": "Name your forum.",
	"cat-admin-forum-desc-placeholder":
		"Enter a brief description of your forum.",

	"cat-admin-blog-name": "Blog Name",
	"cat-admin-blog-name-placeholder": "Name your blog.",
	"cat-admin-blog-desc-placeholder": "Enter a brief description of your blog.",

	"cat-admin-collection-name": "Collection Name",
	"cat-admin-collection-name-placeholder": "Name your collection.",
	"cat-admin-collection-desc-placeholder":
		"Enter a brief description of your collection.",

	"cat-admin-permissions-title": "Permissions",
	"cat-admin-permissions-header-forum":
		"You cannot change the Public/Private setting of a forum once the forum\
		has been created, so <b>make sure you set it correctly now</b>." +
		(AoPS.session.admin
			? '   Any\
		administrators will have this forum added to their "My Forums" automatically.'
			: ""),
	"cat-admin-permissions-header-blog": AoPS.session.admin
		? '  Any\
		administrators will have this blog added to their "My Blogs" automatically.'
		: "",
	"cat-admin-permissions-header-collection":
		"You cannot change the Public/Private setting of a collection once the collection\
		has been created, so <b>make sure you set it correctly now</b>. " +
		(AoPS.session.admin
			? '  Any\
		administrators will have this collection added to their "My Collections" automatically.'
			: ""),
	"cat-admin-permissions-public-heading": "Public/Private",
	"cat-admin-permissions-is-locked": "Status",
	"cat-admin-permissions-open": "Open",
	"cat-admin-permissions-locked": "Locked",
	"cat-admin-permissions-has-source": "Has Source",
	"cat-admin-permissions-inherit-head": "Inherit Roles From",
	"cat-admin-permissions-remove-self":
		"Are you sure you want to remove yourself from the <b>{0}</b> of <b>{1}</b>?",
	"cat-admin-permissions-close-userlist-early":
		"I hate leaving things half-finished.  You started entering\
		a username, but stopped before you finished.  Please either finish entering the username or delete\
		what you have entered.",
	"cat-admin-perms-existing-user":
		"The user <b>{0}</b> is already among the <b>{1}</b>. ",
	"cat-admin-set-role-inherit":
		"Setting role inheritance and assigning roles from parent...",
	"cat-admin-set-inherit-no-perm":
		"You do not have permission to set role inheritance.",
	"cat-admin-set-inherit-invalid-parent":
		"Sorry, you have chosen an invalid parent from which to inherit roles.",
	"cat-admin-no-inherit-from-self":
		"Nice try.  You can't set this to inherit from itself.",
	"cat-admin-inheritance-info":
		"You can set this {0} to inherit roles from some forum or collection. Any user \
		that is given a role on the parent will have the same role here, and any user that loses a role \
		on the parent will lose that role here.",
	"cat-admin-perms-existing-user-3":
		"Click OK to switch the user to the list of",
	"cat-admin-perms-help-title": "Permissions Help",

	"cat-admin-is-public-confirm-warning":
		"Only site admins can toggle public/private status.  This should be done <b>very</b> sparingly.",
	"cat-admin-is-public-blocker":
		"Changing public/private status.  Back shortly...",
	"cat-admin-set-blog-public-warning":
		"Are you sure you want to make this blog public? \
		All users will be able to see all posts in your blog.",
	"cat-admin-set-blog-private-warning":
		"Are you sure you want to make this blog private? \
		Only owners and contributors will be able to see the blog, and the blog will \
		be removed from all collections it is in.",

	"cat-admin-no-add-admin-start": "The user <b>",
	"cat-admin-no-add-admin-end":
		"</b> is an AoPS administrator.  The AoPS administrators have phenomenal powers, so they need not\
		be added to any of your user groups.",

	"cat-admin-lock-blocker": "Calling the locksmith.  Hold on for a minute.",

	"cat-admin-permissions-forum-public-helper":
		"Any user can read this forum.  Any registered user can post and edit tags.",
	"cat-admin-permissions-forum-private-helper":
		"Only users who are given permission to access this forum can read, post, or edit tags.",
	"cat-admin-permissions-forum-locked-helper":
		"No one can post in a locked forum.",
	"cat-admin-permissions-forum-open-helper":
		"Forum is unlocked; anyone who can access can post.",
	"cat-admin-permissions-forum-has-source-helper":
		"Topics have a source field.",
	"cat-admin-permissions-forum-no-source-helper":
		"Topics do not have a source field.",

	"cat-admin-permissions-blog-public-helper":
		"Any user can read this blog.  Any registered user can reply to posts and shout.",
	"cat-admin-permissions-blog-private-helper":
		"Only users who are given permission to access this blog can read posts and reply to them.",
	"cat-admin-permissions-blog-locked-helper":
		"No one can reply to posts or shout; only owners can post.",
	"cat-admin-permissions-blog-open-helper":
		"Blog is unlocked; anyone can reply or shout.",

	"cat-admin-permissions-collection-public-helper":
		"Any user can read this collection.",
	"cat-admin-permissions-collection-private-helper":
		"Only you can access this collection.",
	"cat-admin-permissions-collection-locked-helper":
		"Only collection administrators and moderators can edit the contents of this collection.",
	"cat-admin-permissions-collection-open-helper":
		"Experienced users can edit the contents of this collection.",

	"cat-admin-user-types-forum-owner": "Administrators",
	"cat-admin-user-types-forum-mod": "Moderators",
	"cat-admin-user-types-forum-registered_user": "Users",
	"cat-admin-user-types-forum-deny": "Banned",

	"cat-admin-user-types-collection-owner": "Administrators",
	"cat-admin-user-types-collection-mod": "Moderators",
	"cat-admin-user-types-collection-deny": "Banned",

	"cat-admin-user-types-blog-owner": "Administrators",
	"cat-admin-user-types-blog-contributor": "Contributors",
	"cat-admin-user-types-blog-deny": "Banned",
	"cat-admin-user-types-blog-reader": "Readers",

	"cat-admin-error-E_NOT_LOGGED_IN":
		"You are not currently signed in. You must be signed in to create a new ",
	"cat-admin-error-E_NO_PERMISSION":
		"You no longer have permission to create a new ",
	"cat-admin-error-E_PROTECTED":
		"This category is protected.  Even with your admin superpowers, you cannot delete it or change its public/private status.",
	"cat-admin-error-E_NAME_NOT_AVAILABLE":
		"The name you have chosen is not available.",
	"cat-admin-error-E_NO_SUCH_CATEGORY_TYPE": "No such category type : ",
	"cat-admin-error-E_NAUGHTY_TERM_USED":
		"You have a disallowed term in your name or description.",
	"cat-admin-error-E_NAME_TOO_SHORT":
		"The name is too short. It must be at least " +
		AoPS.Community.Constants.min_category_name_length +
		" characters.",
	"cat-admin-error-E_NAME_TOO_LONG":
		"The name is too long.  It cannot be more than " +
		AoPS.Community.Constants.max_category_name_length +
		" characters.",
	"cat-admin-error-E_DESCRIPTION_TOO_LONG":
		"The description is too long. It cannot be more than " +
		AoPS.Community.Constants.max_category_description_length +
		" characters.",
	"cat-admin-gen-info-error-E_NO_PERMISSION":
		"You do not have permission to make these changes.",
	"cat-admin-error-nothing-saved": "Nothing has been saved!",

	"cat-admin-blog-settings-title": "Blog Settings",

	"cat-admin-blog-label-show_profile_info": "Show Profile",
	"cat-admin-blog-label-is_primary_blog": "Set As Blog In My Profile",
	"cat-admin-blog-label-show_stats": "Show Stats",
	"cat-admin-blog-label-show_shoutbox": "Show Shoutbox",
	"cat-admin-blog-label-show_contributors": "Show Contributors",
	"cat-admin-blog-label-show_tags": "Show Tags",
	"cat-admin-blog-label-show_custom_block": "Show Custom Block",
	"cat-admin-blog-label-blog_post_comment_text": "Post Comment Text",
	"cat-admin-blog-label-blog_comments_text": "Comments Text",
	"cat-admin-blog-label-blog_one_comment_text": "One Comment Text",
	"cat-admin-blog-label-blog_no_comments_text": "No Comments Text",
	"cat-admin-blog-settings-help-title": "Blog Settings Help",

	"cat-admin-blog-css-title": "Blog Custom CSS",
	"cat-admin-blog-css-new-info":
		"Once you have created a blog, you can edit its CSS here.",
	"cat-admin-blog-css-existing-info":
		"Edit your blog's CSS in the textarea below.",
	"cat-admin-blog-css-save-sure":
		"Are you sure you want to save this CSS? This will \
		overwrite any old CSS you have.",
	"cat-admin-blog-css-save-block":
		"Hold on a sec while I save this CSS for you...",
	"cat-admin-blog-css-delete-sure":
		"Are you sure you want to delete this CSS? This blog will then \
		have the default AoPS Blog CSS.",
	"cat-admin-blog-css-delete-block":
		"Hold on a sec while I delete this blog's CSS for you...",
	"cat-admin-blog-css-enter": "Enter CSS for this blog here.",
	"cat-admin-blog-css-none": "This blog does not have any custom CSS.",
	"cat-admin-blog-css-no-perm": "This blog's custom CSS is shown below.",
	"cat-admin-blog-css-no-perm-err":
		"You do not have permission to edit this blog's CSS.",
	"cat-admin-blog-css-help-title": "Blog CSS Help",
	"cat-admin-blog-css-default-css":
		"/** This sets the background color of your blog posts.  Try changing the color and see what happens! **/\n\
div .entrywrap, div .entrywrap-hover {\n\
background-color : #dedede;\n\
}",

	"cat-admin-private-collection-perms":
		"This is a private collection; only you may access it.",
	"cat-admin-location-title": "Location",
	"cat-admin-location-add-to": "Add to",
	"cat-admin-location-contained-in": "Contained in",
	"cat-admin-delete-container-1":
		"Do you really want to remove this from the collection ",
	"cat-admin-location-help-title": "Location Help",
	"cat-admin-add-to-location-placeholder": "Enter collection name",
	"cat-admin-location-exists": "This {0} has already been added to <b>{1}</b>.",
	"cat-admin-no-description": "<i>None</i>",

	"cat-admin-contents-title": "Contents",
	"cat-admin-contents-title-editing":
		'Contents: <span class="cmty-content-edit">Editing</span>',
	//	'cat-admin-contents-add-item' : 'Add Item',
	//	'cat-admin-contents-items-header' : 'Collected Items',
	"cat-admin-contents-help-tooltip": "View Contents Help",
	"cat-admin-add-content-folder-placeholder":
		"Enter forum, collection, or blogroll name",
	"cat-admin-add-content-my_collections-placeholder":
		"Enter collection or blogroll name",
	"cat-admin-add-content-my_forums-placeholder": "Enter forum name",
	"cat-admin-add-content-folder_forums-placeholder": "Enter forum name",
	"cat-admin-add-content-bookmark_forums-placeholder": "Enter forum name",
	"cat-admin-add-content-folder_collections-placeholder":
		"Enter collection or blogroll name",
	"cat-admin-add-content-blogroll-placeholder": "Enter blog name",
	"cat-admin-add-content-my_blogs-placeholder": "Enter blog name",
	"cat-admin-add-content-topic-placeholder": "Enter topic url",
	"cat-admin-contents-building-info":
		"After creating this collection, you will be redirected to \
		this page, and will be able to add items to your collection in this box.",
	"cat-admin-contents-save-blocker": "Saving your changes; back shortly.",
	"cat-admin-contents-save-error":
		"Sorry, something went wrong while I was trying to save. \
		I tried to do as much as I could before hitting the error.  After you hit OK, the page will \
		reload and you'll see what I finished before crashing.<br><br>",
	"cat-admin-contents-unexpected-error":
		" The only additional detail I have is an error code: <b>{0}</b>.",
	"cat-admin-contents-save-error-E_ITEM_NUM_LIMITED":
		"<b>Error details</b>: You have exceeded the number of items allowed in \
		this collection.",
	"cat-admin-contents-save-error-E_NO_SUCH_POST":
		"<b>Error details</b>: You have added \
		a post that no longer exists; perhaps it was just deleted.",
	"cat-admin-contents-save-error-E_NO_PERMISSION":
		"<b>Error details</b>: You have attempted to \
		add a post that you do not have permission to view.",
	"cat-admin-contents-save-error-E_ONLY_PUBLIC_POSTS_ALLOWED":
		"<b>Error details</b>:  You have tried to add a non-public post to this collection. \
		However, this collection is public, \
		so you can only add public posts to this collection. ",
	"cat-admin-contents-save-error-E_NON_FORUM_POST":
		"<b>Error details</b>: Only forum posts are allowed in \
		this collection.  No private messages or blog material is permitted.",
	"cat-admin-contents-no-adding-to-self": "You cannot add this to itself!!!",
	"cat-admin-contents-already-holds":
		"<b>{0}</b> is already in this collection.",
	"cat-admin-view_posts-already-holds": "Post ID {0}",
	"cat-admin-contents-help-title": "Contents Help",
	"cat-admin-contents-tag-placeholder": "Enter tag",
	"cat-admin-contents-add-tag-error":
		"Something went wrong when I tried to add tag <b>{0}</b> of Forum <b>{1}</b>. You may\
		want to refresh and try again.",
	"cat-admin-contents-remove-tag-error":
		"Something went wrong when I tried to delete \
		<b>{0}</b>.  You may want to refresh and try again.",
	"cat-admin-add-content-tag-forum-placeholder":
		"Enter forum whose tags you'd like to add",
	"cat-admin-contents-added-tag-already":
		"The tag <b>{0}</b> of forum <b>{1}</b> has already\
		been added to this collection.",
	"cat-admin-contents-locked-error":
		"Sorry, this collection has just been locked, so\
		you can no longer edit its contents.",
	"cat-admin-contents-add-category-error":
		"Something went wrong when I tried to add <b>{0}</b> to this collection. You may\
		want to refresh and try again. Error code: <b>{1}</b>.",
	"cat-admin-no-empty-collections":
		"You cannot create an empty collection; please add something to this collection.",
	"cat-admin-contents-limit-exceeded":
		"Sorry, this collection cannot hold more than <b>{0}</b> items.",
	"cat-admin-one-more-step":
		"After you click OK, I'll build this collection for you, then \
		bring you right back to this page so you can add items to it.",
	"cat-admin-contents-subscribe": "Receive email notifications if checked",
	"cat-admin-contents-feed": "Appears in Bookmark Feed if checked",
	"cmty-admin-delete-item": "Remove this item.",

	"cat-admin-site-admins-are-admins": "<i>AoPS site admins</i>",
	"cat-admin-no-users-with-this-role": "<i>None</i>",
	"cat-admin-contents-desc-heading": "Contents Description",
	"cat-admin-contents-desc-folder":
		"This collection can hold other collections and forums.",
	"cat-admin-contents-desc-view_topics":
		"This collection can hold only forum topics.",
	"cat-admin-contents-desc-view_posts":
		"This collection can hold posts and custom text.",
	"cat-admin-contents-desc-blogroll": "This collection can hold only blogs.",
	"cat-admin-contents-desc-view_tags": "This collection can hold only tags.",
	"cat-admin-contents-desc-my_forums":
		"This collection can hold any forum you own or moderate, as well as \
		any private forum to which you have access.",
	"cat-admin-contents-desc-my_collections":
		"This collection can hold any collection you own or moderate, as well as \
		any private collection to which you have access.",
	"cat-admin-contents-desc-bookmark_forums":
		"This collection holds all the forums you have \
		bookmarked.",
	"cat-admin-contents-desc-bookmark_users":
		"This collection holds all the users you have \
		bookmarked.",
	"cat-admin-contents-desc-bookmark_tags":
		"This collection holds all the tags you have \
		bookmarked.",
	"cat-admin-contents-desc-bookmark_topics":
		"This collection holds all the topics you have \
		bookmarked.",
	"cat-admin-category-colors": [
		{
			label: "Community",
			color: "#356cb5",
		},
		{
			label: "School",
			color: "#009fad",
		},
		{
			label: "Games",
			color: "#c20078",
		},
		{
			label: "Books",
			color: "#008345",
		},
		{
			label: "Resources",
			color: "#1f3d7b",
		},
	],

	"cat-admin-contents-desc-my_blogs":
		"This collection can hold any blog you own or contribute to, as well as \
		any private blog to which you have access.",
	"cat-admin-contents-desc-folder_forums":
		"This collection can hold only forums.",
	"cat-admin-contents-desc-folder_collections":
		"This collection can hold only collections.",
	"cat-admin-contents-sort-heading": "Sorting",
	"cat-admin-contents-current-state": "Current State",
	"cat-admin-contents-edit-btn": "EDIT CONTENTS",
	"cmty-cat-admin-edit-contents-fetch": "Preparing edit window...",
	"cat-admin-contents-current-tab": "Current Contents",
	"cat-admin-contents-available-tab": "Available Contents",

	"cmty-admin-add-topic-error":
		"You must enter a valid topic id or a URL to a topic \
		that is in a forum.",
	"cmty-admin-add-topic-err-not-forum":
		"You can only add forum topics to this collection.",
	"cmty-admin-add-topic-err-private":
		"This collection is public, so you cannot topics in \
		private forums.",
	"cmty-admin-add-topic-err-no-topic": "Sorry, I cannot find this topic.",
	"cmty-admin-add-topic-err-no-permission":
		"Sorry, you do not have permission to access this topic.",

	"cmty-admin-add-topic-blocker": "Hold on while I fetch this topic for you...",

	"cmty-admin-new-post-error-E_LABEL_TOO_LONG":
		"Your post label is too long; it cannot be more than " +
		AoPS.Community.Constants.view_post_max_label_len +
		" characters",
	"cmty-admin-new-post-error-E_INVALID_POST_ID":
		"You must enter a valid post id or a URL to a forum \
		post.  To find a post URL, click the post number indicator at the top right of a post. The post \
		id is the integer following the p.",
	"cmty-admin-new-post-error-E_HIDE_LABEL_TOO_LONG":
		'Your "Hide Link Text" is too long.  It cannot be more than ' +
		AoPS.Community.Constants.view_post_max_hide_label_len +
		" characters.",
	"cmty-admin-new-post-error-E_NO_CUSTOM_TEXT_ENTERED":
		"To enter a row of custom text, you must \
		enter some custom text!",
	"cmty-admin-new-post-error-E_INVALID_POST_TYPE":
		"You have sent an invalid post type.",
	"cmty-admin-new-post-error-E_BANNED_TERM":
		"You have submitted a banned term.",
	"cmty-admin-new-post-error-E_NO_SUCH_POST":
		"Sorry, that post doesn't appear to exist.",
	"cmty-admin-new-post-error-E_NON_FORUM_POST":
		"You can only add posts that are in forum topics. No \
		blog posts, blog comments, or private messages are allowed.",
	"cmty-admin-new-post-error-E_NO_PERMISSION":
		"You do not have permission to \
		access this post.",
	"cmty-admin-new-post-error-E_ONLY_PUBLIC_POSTS_ALLOWED":
		"This collection is public, so you can \
		only add public posts to it.",
	"cmty-admin-new-post-error-E_POST_IS_DELETED":
		"Sorry, that post has been deleted.",
	"cmty-admin-new-post-error-E_LATEX_ERROR":
		"Sorry, your custom text has a LaTeX error; please fix it and re-submit.",
	"cat-admin-post-construct-blocker":
		"Constructing post item for this collection.",

	"cat-admin-sort-type-system-my_blogs": "Last blog post time",
	"cat-admin-sort-type-system-view_topics": "Last post time",
	"cat-admin-sort-type-system-bookmark_topics": "Last post time",
	"cat-admin-sort-type-system-blogroll": "Last blog post time",
	"cat-admin-sort-type-system-default": "Special",
	"cat-admin-sort-type-manual": "Manual",
	"cat-admin-sort-type-abc": "Alphabetical",
	"cat-admin-sort-type-manual_then_abc": "Some manual, rest alphabetical",
	"cat-admin-sort-type-yyyy": "By year (all items should start with a year)",
	"cat-admin-sort-type-system-other_forums": "Recent Usage",

	"cat-admin-add-heading-blogroll": "Add blog:",
	"cat-admin-add-heading-view_tags": "Tag forum:",
	"cat-admin-add-heading-my_blogs": "Add blog:",
	"cat-admin-add-heading-topic": "Add topic:",
	"cat-admin-add-heading-folder": "Add item:",
	"cat-admin-add-heading-my_forums": "Add forum:",
	"cat-admin-add-heading-folder_forums": "Add forum:",
	"cat-admin-add-heading-folder_collections": "Add collection:",
	"cat-admin-add-heading-my_collections": "Add collection:",
	"cat-admin-troll-confirm":
		"This operation is very difficult to undo. Are you certain you want to ban this user as a troll?",
	"cat-admin-thanks-reset": "This user's thanks have now been reset.",

	/** FEED **/
	/* Topic Full Message */
	"feed-topic-full-message-deleted":
		"The topic you are viewing in the feed has just been deleted.",
	"feed-no-bookmark-options-checked":
		"Work with me here.  If you aren't going to check any options, then I can't fetch you any topics.",
	"feed-new-private-conversation": "Start new message",
	"feed-close": "Close feed",

	"feed-tab-global-title":
		"Global feed\nRecent topics in any forum\nSee Community Help to customize",
	"feed-tab-global-custom-title":
		"Global feed\nRecent topics in select forums\nSee Community Help to customize",
	"feed-tab-my-topics-title": "My Topics feed\nTopics I have posted in",
	"feed-tab-private-title": "Private feed\nMy private messages",
	"feed-tab-bookmark-title":
		"Bookmark feed\nTopics from bookmarked tags, forums, and topics",
	"feed-tab-page-feed-title": "Page feed\n Topics about items on this page",
	"feed-topic-title-tooltip": "Click to visit this topic in main window.",
	"feed-forum-title-tooltip": "Click to visit this forum in main window.",
	"feed-page-subfeed-header": "Page Feed",
	"feed-bookmarks-subfeed-header": "My Bookmarks",
	"feed-global-subfeed-header": "Global Feed",
	"feed-ego-subfeed-header": "My Topics",
	"feed-messages-subfeed-header": "My Messages",
	"feed-no-forum":
		"Sorry, this object does not have a forum attached yet, so you cannot create a new topic.",
	"feed-no-read-permission":
		"Sorry, you don't have permission to read this topic.",
	"feed-no-topic":
		"Well, that's embarrassing.  I can't find the topic attached to this object.",
	"feed-community-disabled": "The community has been disabled.",
	"feed-re-sort": "Re-sort this feed",
	"feed-my-topics-onclick":
		"With {0} of a topic in your My Topics feed, you \
		may either open the topic in another tab or remove the topic from the \
		My Topics feed.  If you remove the topic from the My Topics feed, it \
		will reappear in the My Topics feed if you post in the topic again.",
	"feed-my-topics-open-new": "Open in new tab",
	"feed-my-topics-remove": "Remove from My Topics",

	/** Blogs **/
	"blog-post-new-entry": "Post New Entry",
	"blog-edit-post": "Edit",
	"blog-delete-post": "Delete",
	"blog-moderate-post": "Moderate",
	"blog-report-post": "Report",
	"blog-post-comment": "Comment",
	"blog-shout": "shout",
	"blog-shout-err-E_LATEX_ERROR":
		"Sorry, you have a LaTeX error in your message.",
	"blog-shout-err-E_ASY_ERROR":
		"Sorry, you have an Asymptote error in your message.",
	"blog-shouts": "shouts",
	"blog-Tags": "Tags",
	"blog-Comment": " Comment",
	"blog-Comments": " Comments",
	"blog-default-comments": "%s Comments",
	"blog-default-one-comment": "One Comment",
	"blog-default-no-comments": "No Comments",
	"blog-default-post-comments": "(Post Your Comment)",
	"blog-about-owner": "About Owner",
	"blog-posts": "Posts:",
	"blog-joined": "Joined:",
	"blog-location": "Location:",
	"blog-stats": "Blog Stats",
	"blog-created": "Blog created:",
	"blog-entries": "Total entries:",
	"blog-visits": "Total visits:",
	"blog-comments": "Total comments:",
	"blog-archive-title": "Archives",
	"blog-shoutbox-title": "Shouts",
	"blog-one-char-left": "character left",
	"blog-characters-left": "characters left",
	"blog-no-shoutbox-spamming":
		"You must wait until someone else shouts to shout again!",
	"blog-Entries": "Entries",
	"blog-Entry": "Entry",
	"blog-no-topics": "No posts in this blog.  Yet!",
	"blog-no-results": "No results found.",
	"blog-shout-blocker": "Sending your shout.  Back shortly....",
	"blog-contributors-title": "Contributors",
	"blog-search-heading": "Search Blog",
	"blog-search-placeholder": "Enter term",
	"blog-search-button": "Search",
	"blog-search-advanced": "Advanced Search",
	"blog-search-advanced-tooltip": "View advanced search options",
	"blog-subscribed-notify":
		"You will now receive email notifications when this blog has new posts.",
	"blog-unsubscribed-notify":
		"You will no longer receive email notifications when this blog has new posts.",
	"blog-subscribe-tooltip":
		"Click to receive email notifications for new posts in this blog",
	"blog-unsubscribe-tooltip":
		"Click to stop receiving email notifications for new posts in this blog",
	"change-blog-err-E_NO_PERMISSION":
		"Sorry, you no longer have permission to change this setting. Your changes have not been saved.",
	"blog-shout-no-permission":
		"You do not have permission to shout in this blog.",
	"blog-shout-no-permission-limited":
		'You have a limited account, so you cannot shout in blogs. \
		You can upgrade your account for free <a href="/user/upgrade.php">here</a>.',

	/** Term-tag mapper **/
	"cmty-tag-term-no-tags": "No tags found; press Enter to add as a new tag.",
	"cmty-tag-info-no-match": "No matches found",
	"cmty-tag-info-no-tag": "No tag found",
	"cmty-tag-info-tag": "Tag: ",
	"cmty-tag-mapper-enter-term":
		"Enter term to attach to tag (hit enter to add): ",
	"cmty-tag-info-delete": "DELETE FROM ALL FORUMS",
	"cmty-tag-info-delete-in-checked": "DELETE FROM CHECKED CATEGORIES",
	"cmty-tag-info-delete-everywhere": "DELETE EVERYWHERE (RARE)",
	"cmty-tag-edit-capitalization":
		"New capitalization of tag (enter to submit): ",
	"cmty-tag-info-merge-prompt": "Merge to tag (hit enter to submit): ",
	"cmty-term-add-edit": "Add/edit term",
	"cmty-tag-add-edit": "Add/edit tag",
	"cmty-tag-info-delete-all-fora-confirm":
		"This will delete the tag <b>{0}</b> \
		in all forums.  It will not delete the tag in private messages, nor in blogs. \
		<b>NOT EASILY REVERSIBLE, DO NOT SCREW THIS UP.</b>  Are you sure you want to \
		do this?",
	"cmty-tag-info-recapitalization-fail":
		"The new tag text must be exactly the same as \
		the original text, but with different capitalization. No change will be made until you do it right.",
	"cmty-tag-info-recapitalization-confirm":
		"Are you sure you want to re-capitalize all tags of the \
		form <b>{0}</b> as <b>{1}</b> instead?",
	"cmty-tag-info-recapitalization-blocker": "Being the Fed, back shortly.",
	"cmty-tag-term-mapper-warning":
		"<b>Warning</b>: Changes will not take effect for you until reloading the community in your browser.",

	"cmty-tag-info-delete-some-fora-confirm":
		"This will delete the tag <b>{0}</b> \
		in the following categories: <b><i>{1}</i></b>.<br><br>  \
		<b>NOT EASILY REVERSIBLE, DO NOT SCREW THIS UP.</b>  Are you sure you want to \
		do this?",
	"cmty-tag-info-delete-everywhere-confirm":
		"<b>YOU SHOULD ONLY DO THIS WITH A TAG YOU \
		WANT TO PUT ON THE DENYLIST</b>.  If you go ahead with this, this tag will be removed \
		from everything, and you should immediately talk to a webmasterish person about putting \
		the term on the denylist in CmtyTags.",
	"cmty-tag-info-delete-blocker": "Deleting tag, back shortly...",
	"cmty-tag-info-merge-tag-confirm":
		"Are you sure you want to merge the tag <b>{0}</b> into the tag \
		<b>{1}</b>?  This will only affect tags in forums.<br><br>  <b>THIS IS NOT REVERSIBLE</b>, unless you \
		go through every single topic hand by hand.  Have fun with that. Note: Tag counts for the merged-to \
		tag will not be updated until another topic gets that tag in a forum.  That's because I don't like \
		counting things.",
	"cmty-tag-info-merge-tag-forums-confirm":
		"Are you sure you want to merge the tag <b>{0}</b> into the tag \
		<b>{1}</b>?  This will only affect tags in the following forums: <b><i>{2}</i></b>.<br><br>  <b>THIS IS NOT REVERSIBLE</b>, unless you \
		go through every single topic hand by hand.  Have fun with that. Note: Tag counts for the merged-to \
		tag will not be updated until another topic gets that tag in a forum.  That's because I don't like \
		counting things.",
	"cmty-tag-info-merge-note":
		'<b>Notes on merging</b>: <span style="color:#900"><b>DO NOT USE THIS FOR RESTRICTED/HIDDEN TAGS</b></span>. Also, \
		the system will only recompute tag counts if you manually select fora below, and there are fewer than 5 of them.  Counting is hard, yo. \
		Otherwise, tag counts won\'t get reset until something gets tagged with the merged-to tag.  Most notably, if the \
		merged-to tag did not exist prior to merge, it will only appear in the box after merge if you manually choose few \
		fora for merging.',

	/** View_posts **/
	"view-posts-view-topic": "view topic",

	/** Embeddable fora **/
	"embed-err-no-topic":
		"Sorry, the topic you seek is not in this forum anymore.  Maybe it never was here...",
	/** Embeddable fora **/
	"embed-halper-no-topic":
		"This topic seems to be closed.  Try finding it in <a target='_blank' href=':URL:'>its native forum</a>.",

	/** Memberlist **/
	"memberlist-page-title": "Memberlist",
	"memberlist-user-search": "User Search",
	"memberlist-user-search-placeholder":
		"Enter a username.  Use * as a wildcard.",
	"memberlist-joined": "Joined",
	"memberlist-last-visit": "Last Visit",
	"memberlist-posts": "Posts",
	"memberlist-thanks": "<span>Y</span> Received",
	"memberlist-no-matches": "No users match your search, sorry!",
	"memberlist-posts-tooltip":
		"Number of posts in the community. \nDoes not include posts in the \npink games-related forums.",
	"memberlist-thanks-tooltip":
		"Number of times this user has received a thumbs-up.",

	/** Etc **/
	"userlist-edit": "Edit user list",
	"my-bookmarks-long-desc":
		'Bookmarks allow you to collect content that you would like to access easily from your My AoPS page or your feed.<br>\
		Bookmark a forum, tag, topic, or user by clicking the <span class="aops-font">B</span>Bookmark icon associated with the item.',

	/** Log Admin **/
	"log-admin-confirm-revert":
		"Are you sure you want to revert these {0} action(s)? Make sure you \
		have chosen the correct action(s) to revert; you can't easily reverse this...",
	"log-admin-nothing-to-revert":
		"Um, you have to choose something to revert...",
	"log-admin-blocker-revert": "Hold on while I clean up this mess.",
	"log-admin-page-title": "Log Admin",
	"log-admin-time": "The previous query took <b>{0}</b> milliseconds.",
};

// Font size options in the font-size popup

AoPS.Community.Constants.bbCode.font_sizes = [
	{
		size: 50,
		text: "Too small",
	},
	{
		size: 75,
		text: "Small",
	},
	{
		size: 100,
		text: "Medium",
	},
	{
		size: 150,
		text: "Large",
	},
	{
		size: 200,
		text: "Too large",
	},
];

// Extra options that pop up when you click the three-line menu
if (!AoPS.isUserLimited()) {
	AoPS.Community.Constants.bbCode.extra_options = [
		{
			property: "disable_bbcode",
			text: "Disable bbCode",
			class_id: "cmty-post-extra-disable-bbcode",
		},
		{
			property: "notify_email",
			text: "Subscribe to this topic",
			class_id: "cmty-post-extra-email",
		},
		{
			property: "bookmark_feed",
			text: "Add topic to Bookmarks feed",
			class_id: "cmty-post-extra-add-feed",
		},
	];
} else if (AoPS.in_academy) {
	AoPS.Community.Constants.bbCode.extra_options = [
		{
			property: "disable_bbcode",
			text: "Disable bbCode",
			class_id: "cmty-post-extra-disable-bbcode",
		},
		{
			property: "bookmark_feed",
			text: "Add topic to Bookmarks feed",
			class_id: "cmty-post-extra-add-feed",
		},
	];
} else {
	AoPS.Community.Constants.bbCode.extra_options = [
		{
			property: "disable_bbcode",
			text: "Disable bbCode",
			class_id: "cmty-post-extra-disable-bbcode",
		},
	];
}
